<template>
	<div style="background: #fff;">
		<div class="xieyi-box">

			<div v-if="AirwaysCustomerRules!=null">
				<block v-for="(item,index) in AirwaysCustomerRules" :key="index">					
					<div class="text-c">
						<h1>{{item.Title}} </h1>
					</div>
					<div>
						<div class="pd10">
							<div class="" v-html="sanitizeContent(item.Content)">
								<!-- <text>{{item.Content}}</text> -->
							</div>
						</div>
					</div>
				</block>
			</div>

			<!-- 公共航空运输旅客服务管理规定 -->
			<div v-if="query=='service'">
				<div class="text-c">
					<h1>中华人民共和国交通运输部令</h1>
					<h3 class="mt10">2021 年第3 号</h3>
				</div>
				<div class="pd10 time-name ft14">《公共航空运输旅客服务管理规定》已于 2021 年 2 月
					24 日经第4 次部务会议通过，现予公布，自2021 年9 月1
					日起施行。
				</div>
				<div class="text-r pr20 mt10 mb10 ft14">
					<div>部 长</div>
					<div>2021 年3 月3 日</div>
				</div>
				<div class="text-c">
					<h1>公共航空运输旅客服务管理规定 </h1>

				</div>
				<div v-for="(item,index) in aboutList" :key="index">
					<h3 class="mt10 text-c">{{item.name}}</h3>
					<div class="pd10" v-for="(chapter,i) in item.chapter" :key="i">
						<div class="" v-for="(list,z) in chapter.list" :key="z">
							<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
								class="pl20 ft14">{{list.content1}}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 民用航空危险品运输管理规定 -->
			<div v-if="query=='danger'">

				<div class="text-c">
					<h1>民用航空危险品运输管理规定</h1>

				</div>
				<div v-for="(item,index) in aboutList2" :key="index">
					<h3 class="mt10 text-c">{{item.name}}</h3>
					<div class="pd10" v-for="(chapter,i) in item.chapter" :key="i">
						<div v-if="index==2">


							<div class="" v-for="(list,z) in chapter.list" :key="z">
								<div>
									<div v-if="i==0" class="jie">第一节 一般规定</div>
									<div v-if="i==3" class="jie">第二节 国内经营人危险品航空运输的申请和许可</div>
									<div v-if="i==8" class="jie">第三节 外国经营人危险品航空运输的申请和许可</div>
									<div v-if="i==20" class="jie">第四节 危险品航空运输许可的期限、变更和延期</div>
									<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
										class="pl20 ft14">{{list.content1}}</span>
								</div>
							</div>
						</div>
						<div v-else-if="index==6">


							<div class="" v-for="(list,z) in chapter.list" :key="z">
								<div>
									<div v-if="i==0" class="jie">第一节 经营人的责任</div>
									<div v-if="i==19" class="jie">第二节 经营人的代理人的责任</div>

									<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
										class="pl20 ft14">{{list.content1}}</span>
								</div>
							</div>
						</div>
						<div v-else-if="index==8">


							<div class="" v-for="(list,z) in chapter.list" :key="z">
								<div>
									<div v-if="i==0" class="jie">第一节 一般规定</div>
									<div v-if="i==2" class="jie">第二节 危险品培训大纲</div>
									<div v-if="i==7" class="jie">第三节 培训课程</div>
									<div v-if="i==10" class="jie">第四节 培训要求</div>
									<div v-if="i==13" class="jie">第五节 危险品培训机构</div>
									<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
										class="pl20 ft14">{{list.content1}}</span>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="" v-for="(list,z) in chapter.list" :key="z">
								<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
									class="pl20 ft14">{{list.content1}}</span>
							</div>
						</div>

					</div>
				</div>
			</div>
			<!-- 中华人民共和国民用航空安全保卫条例 -->
			<div v-if="query=='safe'">

				<div class="text-c">
					<h1>中华人民共和国民用航空安全保卫条例 </h1>

				</div>
				<div v-for="(item,index) in aboutList3" :key="index">
					<h3 class="mt10 text-c">{{item.name}}</h3>
					<div class="pd10" v-for="(chapter,i) in item.chapter" :key="i">
						<div class="" v-for="(list,z) in chapter.list" :key="z">
							<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
								class="pl20 ft14">{{list.content1}}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- 中华人民共和国民用航空法-->
			<div v-if="query=='flightRule'">

				<div class="text-c">
					<h1>中华人民共和国民用航空法 </h1>
					<div class="mt10 ft14">(1995 年 10 月 30 日第八届全国人民代表大会常务委员会第十六次会议通过，
						1995 年 10 月 30 日中华人民共和国主席令第五十六号公布)</div>
				</div>
				<div v-for="(item,index) in aboutList4" :key="index">
					<h3 class="mt10 text-c">{{item.name}}</h3>
					<div class="pd10" v-for="(chapter,i) in item.chapter" :key="i">
						<div v-if="index==2">
							<div class="" v-for="(list,z) in chapter.list" :key="z">
								<div>
									<div v-if="i==0" class="jie">第一节 一般规定</div>
									<div v-if="i==4" class="jie">第二节 民用航空器所有权和抵押权</div>
									<div v-if="i==8" class="jie">第三节 民用航空器优先权</div>
									<div v-if="i==16" class="jie">第四节 民用航空器租赁</div>
									<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
										class="pl20 ft14">{{list.content1}}</span>
								</div>
							</div>
						</div>
						<div v-else-if="index==4">
							<div class="" v-for="(list,z) in chapter.list" :key="z">
								<div>
									<div v-if="i==0" class="jie">第一节 一般规定</div>
									<div v-if="i==4" class="jie">第二节 机 组</div>
									<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
										class="pl20 ft14">{{list.content1}}</span>
								</div>
							</div>
						</div>
						<div v-else-if="index==6">
							<div class="" v-for="(list,z) in chapter.list" :key="z">
								<div>
									<div v-if="i==0" class="jie">第一节 空域管理</div>
									<div v-if="i==3" class="jie">第二节 飞行管理</div>
									<div v-if="i==12" class="jie">第三节 飞行保障</div>
									<div v-if="i==20" class="jie">第四节 飞行必备文件</div>
									<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
										class="pl20 ft14">{{list.content1}}</span>
								</div>
							</div>
						</div>
						<div v-else-if="index==8">
							<div class="" v-for="(list,z) in chapter.list" :key="z">
								<div>
									<div v-if="i==0" class="jie">第一节 一般规定</div>
									<div v-if="i==3" class="jie">第二节 运输凭证</div>
									<div v-if="i==20" class="jie">第三节 承运人的责任</div>
									<div v-if="i==33" class="jie">第四节 实际承运人履行航空运输的特别规定</div>
									<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
										class="pl20 ft14">{{list.content1}}</span>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="" v-for="(list,z) in chapter.list" :key="z">
								<strong class="first-span pl20" v-if="z==0">第{{i+1}}条</strong><span
									class="pl20 ft14">{{list.content1}}</span>
							</div>
						</div>

					</div>
				</div>
			</div>
			<!-- 锂电池航空运输规范-->
			<div v-if="query=='transport'">
				<div class="text-c">
					<h1>锂电池航空运输规范 </h1>
				</div>
				<div v-for="(item,index) in aboutList5" :key="index">

					<div class="pd10" v-for="(chapter,i) in item.chapter" :key="i">
						<strong class="first-span pl20">{{i+1}}</strong>
						<div class="" v-for="(list,z) in chapter.list" :key="z" :class="(z==0)?'i-block':''">
							<span :class="(z==0)?'ft14 fb':'ft14'">{{list.smTitle}}</span>
							<span class="pl20 ft14">{{list.content1}}</span>
							<div class="" v-for="(item,z) in list.content2" :key="z">
								<strong class="first-span pl20">{{i+1}}<span>.{{z+1}}</span></strong>
								<div class="" v-for="(item2,y) in item.list2" :key="y" :class="(y==0)?'i-block':''">
									<span :class="(y==0)?'ft14 fb':'ft14'">{{item2.smTitle}}</span>
									<span class="pl20 ft14">{{item2.content1}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div class="table-c">
						<div class="text-c">
							<h3>表1 锂电池按包装说明 965～970 第Ⅰ节运输要求一览表</h3>
						</div>
						<table width="800" border="0" cellspacing="0" cellpadding="0">
							<tr>
								<td rowspan="2">联合国编号和运输专用名称</td>
								<td colspan="4">锂离子电池</td>
								<td colspan="4">锂金属电池</td>
							</tr>
							<tr>
								<td colspan="2">UN3480
									锂离子电池</td>
								<td>UN3481
									锂离子电池与设
									备包装在一起</td>
								<td>UN3481 锂离子电池安 装在设备中</td>
								<td colspan="2">UN3090
									锂金属电池</td>
								<td>UN3091
									锂金属电池与设
									备包装在一起</td>
								<td>UN3091
									锂金属电池安装
									在设备中</td>
							</tr>

							<tr>
								<td rowspan="2">包装说明</td>
								<td colspan="2">965</td>
								<td rowspan="2">966</td>
								<td rowspan="2">967</td>
								<td colspan="2">968</td>
								<td rowspan="2">969</td>
								<td rowspan="2">970</td>
							</tr>
							<tr>
								<td>IA</td>
								<td>IB</td>
								<td>IA</td>
								<td>IB</td>

							</tr>
							<tr>
								<td>IMP代码</td>
								<td>RBI</td>
								<td>RBI </td>
								<td>RLI </td>
								<td>RLI</td>
								<td>RBM </td>
								<td>RBM </td>
								<td>RLM </td>
								<td>RLM </td>
							</tr>
							<tr>
								<td rowspan="2">测试要求</td>
								<td>——</td>
								<td>包装件1.2 m跌落试验</td>
								<td>—— </td>
								<td>—— </td>
								<td>>——</td>
								<td>包装件1.2 m跌落试验 </td>
								<td>—— </td>
								<td>>——</td>
							</tr>
							<tr>
								<td colspan="8">锂电池芯或电池UN38.3试验
								</td>
							</tr>
							<tr>
								<td>制造要求
								</td>
								<td colspan="8">电池芯或电池的制造应按ICAO TI中2;9.3.1e）或IATA DGR3.9.2.6e)规定的质量管理体系进行。
								</td>

							</tr>
							<tr>
								<td>锂含量和额
									定能量限制
									b</td>
								<td>锂离子电池芯
									的额定能量超
									过20 Wh，锂离
									子电池的额定
									能量超过100 Wh</td>
								<td>锂离子电池芯的额定能量
									不超过20 Wh，锂离子电池
									的额定能量不超过100 Wh，
									但每个包装件内电池芯或
									电池的个数及净数量超过
									了表2允许的数量限制</td>
								<td colspan="2">锂 离 子 电 池 芯 的 额 定 能 量 超 过
									20 Wh，锂离子电池的额定能量超过
									100 Wh</td>
								<td>锂金属电池芯的
									锂含量超过1 g，
									锂金属电池的锂
									含量超过2 g</td>
								<td>锂金属电池芯的锂含量
									不超过1 g，锂金属电池
									的锂含量不超过2 g，但
									每个包装件内电池芯或
									电池的个数和净数量超
									过了表2允许的数量限制 </td>
								<td colspan="2">锂金属电池芯的锂含量超过1 g，
									锂金属电池的锂含量超过2 g </td>

							</tr>
							<tr>
								<td>荷电状态</td>
								<td colspan="2">不应超过30%
								</td>
								<td>—— </td>
								<td>—— </td>
								<td>—— </td>
								<td>—— </td>
								<td colspan="2">—— </td>

							</tr>
							<tr>
								<td>包装规格</td>
								<td>UN规格
								</td>
								<td>—— </td>
								<td>UN规格 </td>
								<td>—— </td>
								<td>UN规格 </td>
								<td>—— </td>
								<td>UN规格 </td>
								<td>—— </td>
							</tr>
							<tr>
								<td>包装限量</td>
								<td>客机禁运。
									每个包装件中
									锂电池芯或电
									池的净数量在
									货机上不超过
									35 kg
								</td>
								<td>客机禁运。
									每个包装件中锂电池芯或
									电池的净数量在货机上不
									超过10 kg </td>
								<td>每个包装件中锂
									电池芯或电池的
									净数量在客机上
									不超过5 kg，在货
									机上不超过35 kg </td>
								<td>每个包装件中
									锂电池芯或电
									池的净数量在
									客机上不超过
									5 kg，在货机上
									不超过35 kg </td>
								<td>客机禁运。
									每个包装件中锂
									电池芯或电池的
									净数量在货机上
									不超过35 kg</td>
								<td>客机禁运。
									每个包装件中锂电池芯
									或电池的净数量在货机
									上不超过2.5 kg </td>
								<td>每个包装件中锂
									电池芯或电池的
									净数量在客机上
									不超过5 kg，在
									货 机 上 不 超 过
									35 kg </td>
								<td>每个包装件中锂电
									池芯或电池的净数
									量在客机上不超过
									5 kg，在货机上不
									超过35 kg</td>
							</tr>
							<tr>
								<td>包装要求
								</td>
								<td colspan="8">1.
									锂电池芯和电池应装入能将电池芯或电池完全封装的内包装中，然后再放入坚固、结实的外包装；应采取措施保护电池芯和电池防止发生短路（包括防止在同一包装内
									与导电材料接触，导致发生短路）。
									2. UN规格包装应符合包装等级Ⅱ级的性能标准。
									3. PI965的IA和PI968的IA：质量为12
									kg或更大的且具有耐冲撞坚固外壳的锂电池或此类电池组件，经始发国有关当局批准，可放在非UN规格的坚固外包装和保护封罩中（如
									完全密闭的箱子或木质板条箱）进行运输。批准文件应随附托运货物。
									4. PI969的第I部分要求，交付客机运输的锂金属电池芯和电池，应装入中层或外层硬金属包装，并用不可燃、不导电的衬垫材料将锂金属电池芯和电池裹好，然后将其放
									入外包装内。
									5. 设备应在外包装内得到固定以免移动，并配备防止发生意外启动的有效装置。
									6.
									按包装说明965第IA或IB节准备的托运货物，每个集合包装只能放入1件符合包装说明965第II节的包装件；按照包装说明968第IA或IB节准备的托运货物，每个集合包装
									也只能放入1件符合包装说968第II节的包装件。
									7. 锂电池货物按照包装说明 965 和 968 准备时，不应与第 1 类（1.4S 除外）第 2.1 项、第 3 类、第 4.1 项和第 5.1
									项危险品货物放入同一外包装中。
									8. 按包装说明 965 和 968 准备时，锂电池货物包装件不应与第 1 类（1.4S 除外）第 2.1 项、第 3 类、第 4.1 项和第 5.1
									项危险品包装件做成集合包装件。
									9．其他包装要求详见 ICAO TI 和 IATA DGR 包装说明 965～970 的第 I 节。
								</td>

							</tr>
							<tr>
								<td>标记和标签
								</td>
								<td colspan="8">1. 托运人和收货人全称和地址、联合国编号和运输专用名称、“集合包装（OVERPACK）”字样（如适用）等。
									2. 每个包装件应粘贴第9类锂电池危险性标签、仅限货机标签（如适用），按照IB运输的包装件还应有填写完整的锂电池标记，见附录A。
									3. 集合包装（overpack）上应粘贴第9类锂电池危险性标签、仅限货机标签（如适用）和锂电池标记（如适用），除非集合包装内的所有标签都清晰可见。
									4. 根据特殊规定A181， 如果包装件既含有装在设备中的锂电池，也含有与设备包装在一起的锂电池，则包装件应根据情况，标明UN 3091 Lithium metal
									batteries packed
									with equipment（与设备包装在一起的锂金属电池）或UN 3481 Lithium ion batteries packed with
									equipment（与设备包装在一起的锂离子电池）。如果包装件既含有
									锂金属电池，也含有锂离子电池，则包装件应根据要求同时标明这两种电池类型。但是不必考虑装在设备中（包括线路板在内）的纽扣电池。危险品申报单也应据此填写。
									托运人还应确保符合两个包装说明的所有适用部分，所有包装件中含有的锂电池的总质量不应超过适用情况下的客机或货机的限值。
								</td>

							</tr>
							<tr>
								<td>文件
								</td>
								<td colspan="8">1. 应填写托运人危险品申报单(参见附录B)、收运检查单、机长通知单等。
									2. 运输UN3480时，危险品申报单的附加操作说明栏内应注明交运的锂电池芯或锂电池的荷电状态不超过其额定容量的30%。
								</td>

							</tr>
							<tr>
								<td>差异
								</td>
								<td colspan="8">遵守适用的国家和经营人差异
								</td>

							</tr>
							<tr>
								<td colspan="9">每个包装件均应能承受任何取向的 1.2 m
									跌落试验，而且不损坏包装件内的锂电池芯或电池，未改变包装件内装物的位置以至锂电池芯之间或锂电池之间互相接触，没有内装物自包
									装件中漏出。
									b 额定能量应按照 5.3 的要求在电池外壳上标明。对于标注不清晰或未标注，也没有其他证明，无法确定电池中锂含量或电池额定能量的电池，经营人可以拒绝运输。
									c 根据特殊规定 A99，锂电池已经通过 UN38.3 要求的测试且其包装符合 ICAO TI 和 IATA DGR 包装说明 965-970
									的要求，如果经始发国主管当局批准，并将一份该文件随机，则货机运
									输的每个包装件的数量可超过 35 kg 的最大限制。
								</td>


							</tr>
						</table>
					</div>
					<div class="table-c">
						<div class="text-c">
							<h3>表2 锂电池按包装说明 965～970 第Ⅱ节运输要求一览表</h3>
						</div>
						<table width="800" border="0" cellspacing="0" cellpadding="0">
							<tr>
								<td rowspan="2">联合国编号和运输专用名称</td>
								<td colspan="4">锂离子电池</td>
								<td colspan="4">锂金属电池</td>
							</tr>
							<tr>
								<td colspan="2">UN3480
									锂离子电池</td>
								<td>UN3481
									锂离子电池与设
									备包装在一起</td>
								<td>UN3481 锂离子电池安 装在设备中</td>
								<td colspan="2">UN3090
									锂金属电池</td>
								<td>UN3091
									锂金属电池与设
									备包装在一起</td>
								<td>UN3091
									锂金属电池安装
									在设备中</td>
							</tr>

							<tr>
								<td>包装说明</td>
								<td colspan="2">965</td>
								<td>966</td>
								<td>967</td>
								<td colspan="2">968</td>
								<td>969</td>
								<td>970</td>
							</tr>
							<tr>
								<td>IMP代码</td>
								<td colspan="2">ELI</td>
								<td>ELI</td>
								<td>ELI</td>
								<td colspan="2">ELM</td>
								<td>ELM</td>
								<td>ELM</td>
							</tr>

							<tr>
								<td rowspan="2">测试要求</td>

								<td colspan="3">包装件1.2 m跌落试验</td>
								<td>—— </td>

								<td colspan="3">包装件1.2 m跌落试验 </td>
								<td>—— </td>

							</tr>
							<tr>
								<td colspan="8">锂电池芯或电池UN38.3试验
								</td>
							</tr>
							<tr>
								<td>制造要求
								</td>
								<td colspan="8">电池芯或电池的制造应按照ICAO TI2;9.3.1e）或IATA DGR3.9.2.6e)规定的质量管理体系进行

								</td>

							</tr>
							<tr>
								<td>锂含量和额
									定能量限制
									a
								</td>
								<td colspan="4">锂离子电池芯的额定能量不超过20 Wh
									锂离子电池的额定能量不超过100 Wh</td>
								<td colspan="4">锂金属电池芯的锂含量不超过1 g
									锂金属电池的锂含量不超过2 g</td>

							</tr>
							<tr>
								<td>荷电状态</td>
								<td colspan="2">不应超过30%</td>
								<td>—— </td>
								<td>—— </td>
								<td colspan="4">—— </td>

							</tr>
							<tr>
								<td>包装规格和
									类型</td>
								<td colspan="8">可使用非 UN 规格包装。外包装应坚固、结实，适用的类型为圆形桶、方形桶、箱。
								</td>

							</tr>
							<tr>
								<td>包装限量</td>
								<td colspan="2">客机禁运。
									若 锂 电 池 芯 或 锂 电 池 的 能 量 不 超
									过 2.7 Wh：个数不限，每个包装件中锂
									电池芯或电池净数量不超过2.5 kg；
									若锂电池芯的能量超过2.7 Wh但不超过
									20 Wh：每个包装件最多8块电池芯，净
									数量不限；
									若锂电池的能量超过2.7 Wh但不超过100
									Wh：每个包装件最多2块电池，净数量不
									限。
									以上数量不应合并用于同一个包装件。
								</td>
								<td>每个包装件内锂电池
									芯或电池的净数量在
									客机和货机上均不超
									过5 kg，同时每个包装
									件内锂电池芯或电池
									的个数不超过设备运
									行所需的电池数量加
									上2块备用电池。 </td>
								<td>每个包装件内锂电池
									芯或电池的净数量在
									客机和货机上均不超
									过5 kg </td>
								<td colspan="2">客机禁运。
									若锂电池芯或电池的锂含量不超过0.3 g：
									个数不限，每个包装件中锂电池芯或电池
									的净数量不超过2.5 kg；
									若锂电池芯的锂含量超过0.3 g但不超过
									1 g：每个包装件最多8块电池芯，净数量
									不限；
									若锂电池的锂含量超过0.3 g但不超过
									2 g：每个包装件最多2块电池，净数量不
									限。
									以上数量不应合并用于同一个包装件</td>
								<td>每个包装件内锂电
									池芯或电池的净数
									量在客机和货机上
									均不超过5 kg，同时
									每个包装件内电池
									芯或电池的个数不
									超过设备运行所需
									的电池数量加上2块
									备用电池。</td>
								<td>每个包装件内锂
									电池芯或电池的
									净数量在客机和
									货机上均不超过5
									kg。 </td>

							</tr>
							<tr>
								<td>包装要求
								</td>
								<td colspan="8">1.
									锂电池芯和电池应装入能将电池芯或电池完全封装的内包装内，然后再放入坚固、结实的外包装；应保护电池芯和电池防止发生短路（包括防止在同一包装内与导电材料相互
									接触，导致发生短路）。
									2. 除安装在设备中的情况外，每个包装件均应能够承受任何取向的1.2 m跌落试验，而且不损坏包装件内的锂电池芯或电池，未改变包装件内装物的位置以至锂电池芯之间或锂
									电池之间互相接触，没有内装物自包装件中漏出。
									3. 除安装在设备中的情况外，电池芯和电池应置于可完全封闭的内包装中，且实际采用的包装应与进行1.2 m跌落试验所使用的包装一致。
									4. 设备应在外包装内得到固定以免移动，并配备防止发生意外启动的有效装置。
									5. 除非安装电池的设备已经对电池提供了等效保护，否则，设备应装在由合适材料制成坚固的外包装内，材料的强度和设计应与包装容量和用途相符。
									6. 无线射频识别（RFID）标签、手表和温度记录仪等无法产生危险热量的装置，在故意激活状态下可以运输。这些装置在激活状态下，应满足规定的电磁辐射标准，确保装置的
									运行不会对航空器系统产生干扰。应确保运输途中该装置不会发出干扰信号（如蜂鸣警报、灯光闪烁等）。
									7. 在任何一票货物中，符合包装说明965第II节要求的锂离子电池（UN3480）货物包装件和/或集合包装不应超过1件。
									8.
									每个集合包装中符合包装说明965第II节要求的锂离子电池（UN3480）货物包装件不应超过1件。每个按包装说明965第IA或IB节准备的集合包装只能放入1件符合包装说965第II
									节的包装件。
									9. 按包装说明965第II 节准备的锂离子电池包装件和集合包装，应与非危险品货物分开交付提交给经营人，并且在提交给经营人之前不应装入集装器。
									10. 第7-9条要求也适用于按包装说明968第II节准备的锂金属电池（UN3090）托运货物。
									11. 锂电池货物按照包装说明 965 和 968 准备时，不应与第 1 类（1.4S 除外）第 2.1 项、第 3 类、第 4.1 项和第 5.1
									项危险品货物放入同一外包装中。
									12. 按包装说明 965 和 968 准备时，锂电池货物包装件不应与第 1 类（1.4S 除外）第 2.1 项、第 3 类、第 4.1 项和第 5.1
									项危险品包装件做成集合包装件。
									13．其他包装要求见ICAO TI 和IATA DGR包装说明965～970的第Ⅱ节。
								</td>

							</tr>
							<tr>
								<td>标记和标签
								</td>
								<td colspan="8">1. 每个包装件外部应有填写完整的大小合适的锂电池标记（见附录A）。包装件的大小应使得有足够空间在某一侧贴标记，且标记不会出现折叠。
									2. 单独运输的锂金属电池（UN3090）和锂离子电池（UN3480）托运货物，每个包装件上还应粘贴仅限货机标签。如果包装件有足够的尺寸，应将锂电池标记和仅限货机标签贴
									在同一面上。
									3. 锂电池安装在设备中的托运货物，以下两种情况可不贴锂电池标记：
									――包装件中仅含有装在设备（包括线路板）中的纽扣式电池；
									――每一票货运单托运货物的包装件数不超过两件，并且每个包装件中不超过四个电池芯或不超过两个电池。
									4.
									集合包装(OVERPACK)上应有锂电池标记和仅限货机标签（如适用），并标记“集合包装（OVERPACK）”字样，除非集合包装（OVERPACK）内的所有标记和标签都清晰可见。
									5. 根据特殊规定A181，如果包装件既含有装在设备中的锂电池，也含有与设备包装在一起的锂电池，则包装件应根据情况，标明UN 3091 Lithium metal
									batteries packed with
									equipment（与设备包装在一起的锂金属电池）或UN 3481 Lithium ion batteries packed with
									equipment（与设备包装在一起的锂离子电池）。如果包装件既含有锂金属电池，
									也含有锂离子电池，则包装件应根据要求标明这两种电池类型，但不必考虑装在设备中（包括线路板在内）的纽扣电池。托运人还应确保符合两个包装说明的所有适用部分，所
									有包装件中含有的锂电池的总质量不应超过适用情况下的客机或货机的限值
								</td>

							</tr>
							<tr>
								<td>文件
								</td>
								<td colspan="8">1. 如使用航空货运单，货运单上应注明锂电池符合相应包装说明第Ⅱ节的规定，例如“锂离子电池, 符合包装说明965第Ⅱ节，仅限货机（lithium
									ion
									batteries, in compliance with
									Section II of PI965，CAO）”（参见附录C）。对于锂电池安装在设备中运输的，如果包装件上未粘贴有锂电池标记，航空货运单上可不注明。
									2. 运输UN3480时，航空货运单上应注明交运的锂电池芯或锂电池的荷电状态不超过其额定容量的30%（参见附录C）。
								</td>

							</tr>
							<tr>
								<td>差异
								</td>
								<td colspan="8">遵守适用的国家和经营人差异
								</td>

							</tr>
							<tr>
								<td colspan="9">额定能量应按照 5.3
									的要求在电池外壳上标明。对于标注不清晰或未标注，也没有其他证明，无法确定电池中锂含量或电池额定能量的电池，经营人可以拒绝运输。
									b 如果包装件既含有装在设备中、也含有与设备包装在一起、符合第Ⅱ节锂电池芯或电池限制的锂电池，则适用以下要求：
									――托运人应确保符合两项包装说明的所有适用部分。包装件中含有的锂电池的总质量不应超过 5 kg；
									――如果使用航空货运单，货运单上应写明“锂离子电池，符合 PI 966 第Ⅱ节”或“锂金属电池，符合 PI969 第 II 节”的字样。
								</td>


							</tr>
						</table>
					</div>
					<div class="table-c">
						<div class="text-c">
							<h3>表3 锂电池和含锂电池设备行李运输一览表</h3>
						</div>
						<table width="800" border="0" cellspacing="0" cellpadding="0">
							<tr>
								<td rowspan="2"></td>
								<td colspan="4">含锂电池设备 </td>
								<td colspan="4">备用锂电池</td>
							</tr>
							<tr>
								<td>PED</td>
								<td>电子吸烟
									装置</td>
								<td>PMED </td>
								<td>电动轮椅 </td>
								<td>PED
									（含充电
									宝） </td>
								<td>电子吸烟
									装置 </td>
								<td>PMED </td>
								<td>电动轮椅 </td>
							</tr>
							<tr>
								<td rowspan="2">额定能量
									/锂含量</td>
								<td>≤100 Wh或≤
									2 g </td>
								<td>≤100 Wh
									或≤2 g</td>
								<td>≤100 Wh
									或≤2 g</td>
								<td>电池可卸，
									不超过
									300 Wh
									电池不可
									卸，额定能
									量不限</td>
								<td>≤100 Wh
									或≤2 gg</td>
								<td rowspan="2">≤100 Wh
									或≤2 g</td>
								<td>≤100 Wh
									<!-- 或≤2 g</td> -->
								<td>≤160 Wh
									经营人批
									准</td>
							</tr>
							<tr>
								<td>100 Wh～160
									Wh
									经营人批准</td>
								<td>- </td>
								<td>100 Wh～
									160 Wh
									或2 g～8 g
									经营人批
									准</td>
								<td>-</td>

								<td>100 Wh～
									160 Wh
									经营人批
									准</td>
								<td>100 Wh～
									160 Wh
									或2 g～8 g
									经营人批
									准</td>

								<td>≤300 Wh
									经营人批
									准</td>
							</tr>
							<tr>

								<td>每人携带
									数量</td>
								<td colspan="4">-</td>
								<td colspan="3">100 Wh～160 Wh的，不超过2个</td>

								<td>2个不超过
									160 Wh，
									或1个不超
									过300 Wh</td>

							</tr>
							<tr>

								<td>行李类型</td>
								<td>托运、手提
									或随身</td>
								<td>1禁止托运</td>
								<td>托运、手提
									或随身</td>
								<td>托运电池
									如可卸，应
									卸下并手
									提</td>
								<td colspan="4">禁止托运</td>
							</tr>
							<tr>
								<td>保护措施</td>
								<td>防意外启动
									防损坏
									托运时完全
									关闭（不在
									睡眠或休眠
									模式）</td>
								<td>防意外启动
									全程关闭
									禁止在飞机
									上充电或使
									用</td>
								<td>防意外启动
									防损坏
									托运时完全
									关闭（不在
									睡眠或休眠
									模式） </td>
								<td>电 池 防 短
									路防受损 </td>
								<td>单 个 保 护
									防短路
									充 电 宝 应
									防 止 意 外
									启动，全程
									关闭，禁止
									在 飞 机 上
									充 电 或 使
									用 </td>
								<td>单个保护
									防短路
									禁止在飞
									机上充电 </td>
								<td>单 个 保 护
									防短路 </td>
								<td>电池防短
									路防受损 </td>
							</tr>
							<tr>
								<td>通知机长</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>通知机长</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>通知机长</td>
							</tr>
						</table>
					</div>
					<div class="mt20">
						<div class="text-c">
							<h3>附 录 A
								（规范性附录）
								锂电池标签和标记</h3>

						</div>
						<el-row class="item-box" :gutter="24" align="middle">

							<el-col class="text-c item-pic" :lg="8">
								<img src="../../assets/xieyi/1.png" style="width:56%;height:180px;">
								<div>第 9 类危险性标签-锂电池</div>
								<div>（100 mm×100 mm） </div>
								<div>注：此标签从 2017 年 1 月 1 日起使用。 </div>
							</el-col>
							<el-col class="text-c item-pic" :lg="8">
								<img src="../../assets/xieyi/2.png" style="width:56%;height:180px;">
								<div>第 9 类危险性标签</div>
								<div>（100 mm×100 mm） </div>
								<div>注：此标签可用至 2018 年 12 月 31 日。 </div>
							</el-col>
							<el-col class="text-c item-pic" :lg="8">
								<img src="../../assets/xieyi/3.png" style="width:56%;height:180px;">
								<div>仅限货机标签</div>
								<div>（最小尺寸：120 mm×110 mm） </div>

							</el-col>
							<el-col class="text-c item-pic" :lg="8">
								<img src="../../assets/xieyi/4.png" style="width:56%;height:180px;">
								<div>锂电池标记</div>
								<div>（120 mm×110 mm或105 mm×74 mm） </div>
								<div>注1：*处填写联合国编号，**处填写可获取信息的电话号码。 </div>
								<div>注 2：此标记从 2017 年 1 月 1 日起使用。 </div>
							</el-col>
							<el-col class="text-c item-pic" :lg="8">
								<img src="../../assets/xieyi/5.png" style="width:56%;height:180px;">
								<div>锂电池操作标签</div>
								<div>注1：*处填写锂离子电池和（或）锂金属电池。
									注 2：此标记从 2017 年 1 月 1 日起使用。
									注 2：此标签可用至 2018 年 12 月 31 日。 </div>

							</el-col>
						</el-row>
					</div>
					<div class="mt20">
						<div class="text-c">
							<h3>
								附 录 B
								（资料性附录）
								危险品申报单节选样例
							</h3>
						</div>
						<div>
							<div class="text-c">
								<img src="../../assets/xieyi/6.png" style="width:50%">

							</div>

						</div>
					</div>
					<div class="mt20">
						<div class="text-c">
							<h3>
								附 录 C
								（资料性附录）
								航空货运单节选样例
							</h3>
						</div>
						<div>
							<div class="text-c">
								<img src="../../assets/xieyi/7.png" style="width:50%">

							</div>

						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
	var that;
	var util = require('@/utils/util.js');
	var yqfCommon = require('@/utils/yqfCommon.js'); //通用类库
	var yqfApi = require('@/api/yqfApi.js');
	import { sanitizeHtml } from '@/utils/htmlSanitizer';

	export default {
		components: {},
		methods: {
			// 安全的内容处理（防止XSS攻击）
			sanitizeContent(content) {
				if (!content) return ''
				return sanitizeHtml(content)
			}
		},
		data() {
			return {
				aboutList: [{
						name: "第一章 总 则",
						chapter: [{
								list: [{
										content1: "为了加强公共航空运输旅客服务管理，保护旅客合法权益， 维护航空运输秩序， 根据《 中华人民共和国民用航空法》《 中华人民共和国消费者权益保护法》《 中华人民共和国电子商务法》 等法律、 行政法规， 制定本规定。 "
									},

								],
							},
							{
								list: [{
										content1: "依照中华人民共和国法律成立的承运人、机场管理机构、 地面服务代理人、 航空销售代理人、 航空销售网络平台经营者、 航空信息企业从事公共航空运输旅客服务活动的， 适用本规定。 "
									},
									{
										content1: "外国承运人、港澳台地区承运人从事前款规定的活动，其航班始发地点或者经停地点在中华人民共和国境内（不含港澳台，下同）的，适用本规定。 "
									},
								],
							},

							{
								list: [{
										content1: "中国民用航空局（以下简称民航局）负责对公共航空运输旅客服务实施统一监督管理。 "
									},
									{
										content1: "中国民用航空地区管理局（以下简称民航地区管理局）负责对本辖区内的公共航空运输旅客服务实施监督管理。 "
									},
								],
							},

							{
								list: [{
									content1: "依照中华人民共和国法律成立的承运人、机场管理机构应当建立公共航空运输旅客服务质量管理体系，并确保管理体系持续有效运行。"
								}, ],
							},
							{
								list: [{
									content1: "鼓励、支持承运人、机场管理机构制定高于本规定标准的服务承诺。"
								}, {
									content1: "承运人、机场管理机构应当公布关于购票、乘机、安检等涉及旅客权益的重要信息，并接受社会监督。"
								}, ],
							},
						],

					},
					{
						name: "第二章 一般规定",
						chapter: [{
								list: [{
										content1: "承运人应当根据本规定制定并公布运输总条件，细化相关旅客服务内容。 "
									},
									{
										content1: "承运人的运输总条件不得与国家法律法规以及涉及民航管理的规章相关要求相抵触。 "
									},

								],
							},
							{
								list: [{
										content1: "承运人修改运输总条件的，应当标明生效日期。,"
									},
									{
										content1: "修改后的运输总条件不得将限制旅客权利或者增加旅客义务的修改内容适用于修改前已购票的旅客，但是国家另有规定的除外。"
									},
								],
							},

							{
								list: [{
									content1: "运输总条件至少应当包括下列内容：（一）客票销售和退票、变更实施细则；（二）旅客乘机相关规定，包括婴儿、孕妇、无成人陪伴儿童、重病患者等特殊旅客的承运标准；（三）行李运输具体要求；（四）超售处置规定；（五）受理投诉的电子邮件地址和电话。前款所列事项变化较频繁的，可以单独制定相关规定，但应当视为运输总条件的一部分，并与运输总条件在同一位置以显著方式予以公布。 "
								}, ],
							},

							{
								list: [{
										content1: "承运人应当与航空销售代理人签订销售代理协议，明确公共航空运输旅客服务标准，并采取有效措施督促其航空销售代理人符合本规定相关要求。"
									},
									{
										content1: "承运人应当将客票销售、客票变更与退票、行李运输等相关服务规定准确提供给航空销售代理人；航空销售代理人不得擅自更改承运人的相关服务规定。"
									},
								],
							},
							{
								list: [{
									content1: "航空销售网络平台经营者应当对平台内航空销售代理人进行核验，不得允许未签订协议的航空销售代理人在平台上从事客票销售活动。"
								}, {
									content1: "航空销售网络平台经营者应当处理旅客与平台内航空销售代理人的投诉纠纷，并采取有效措施督促平台内的航空销售代理人符合本规定相关要求。"
								}, ],
							},
							{
								list: [{
									content1: "承运人应当与地面服务代理人签订地面服务代理协议，明确公共航空运输旅客服务标准，并采取有效措施督促其地面服务代理人符合本规定相关要求。"
								}],
							},
							{
								list: [{
									content1: "机场管理机构应当建立地面服务代理人和航站楼商户管理制度，并采取有效措施督促其符合本规定相关要求。"
								}, ],
							},
							{
								list: [{
									content1: "航空信息企业应当完善旅客定座、乘机登记等相关信息系统功能，确保承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者等能够有效实施本规定要求的服务内容。"
								}, ],
							},
							{
								list: [{
									content1: "承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者、航空信息企业应当遵守国家关于个人信息保护的规定，不得泄露、出售、非法使用或者向他人提供旅客个人信息。"
								}, ],
							},
						],

					},
					{
						name: "第三章  客票销售",
						chapter: [{
								list: [{
										content1: "承运人或者其航空销售代理人通过网络途径销售客票的，应当以显著方式告知购票人所选航班的主要服务信息，至少应当包括： （一）承运人名称，包括缔约承运人和实际承运人； （二）航班始发地、经停地、目的地的机场及其航站楼； （三）航班号、航班日期、舱位等级、计划出港和到港时间；（四）同时预订两个及以上航班时，应当明确是否为联程航班； （五）该航班适用的票价以及客票使用条件，包括客票变更规则和退票规则等； （六）该航班是否提供餐食； （七）按照国家规定收取的税、费； （八）该航班适用的行李运输规定，包括行李尺寸、重量、免费行李额等。 承运人或者其航空销售代理人通过售票处或者电话等其他方式销售客票的，应当告知购票人前款信息或者获取前款信息的途径。  "
									},

								],
							},
							{
								list: [{
										content1: "承运人或者其航空销售代理人通过网络途径销售客票的，应当将运输总条件的全部内容纳入到旅客购票时的必读内容，以必选项的形式确保购票人在购票环节阅知。"
									},
									{
										content1: "承运人或者其航空销售代理人通过售票处或者电话等其他方式销售客票的，应当提示购票人阅读运输总条件并告知阅读运输总条件的途径"
									},
								],
							},

							{
								list: [{
									content1: "  承运人或者其航空销售代理人在销售国际客票时，应当提示旅客自行查阅航班始发地、经停地或者目的地国的出入境相关规定。"
								}, ],
							},

							{
								list: [{
									content1: "购票人应当向承运人或者其航空销售代理人提供国家规定的必要个人信息以及旅客真实有效的联系方式。"
								}],
							},
							{
								list: [{
									content1: "承运人或者其航空销售代理人在销售客票时，应当将购票人提供的旅客联系方式等必要个人信息准确录入旅客定座系统。"
								}],
							},
							{
								list: [{
									content1: "承运人或者其航空销售代理人出票后，应当以电子或者纸质等书面方式告知旅客涉及行程的重要内容，至少应当包括： （一）本规定第十五条第一款所列信息； （二）旅客姓名； （三）票号或者合同号以及客票有效期； （四）出行提示信息，包括航班始发地停止办理乘机登记手续的时间要求、禁止或者限制携带的物品等； （五）免费获取所适用运输总条件的方式。 "
								}],
							},
							{
								list: [{
									content1: "机场管理机构应当建立地面服务代理人和航站楼商户管理制度，并采取有效措施督促其符合本规定相关要求。"
								}, ],
							},
							{
								list: [{
									content1: " 承运人、航空销售代理人、航空销售网络平台经营者、航空信息企业应当保存客票销售相关信息，并确保信息的完整性、保密性、可用性。 "
								}, ],
							},
							{
								list: [{
									content1: "前款规定的信息保存时间自交易完成之日起不少于 3年。法律、行政法规另有规定的，依照其规定。"
								}, ],
							},
						],

					},
					{
						name: "第四章    客票变更与退票 ",
						chapter: [{
								list: [{
										content1: "客票变更，包括旅客自愿变更客票和旅客非自愿变更客票。 "
									},
									{
										content1: "退票，包括旅客自愿退票和旅客非自愿退票。 "
									},

								],
							},
							{
								list: [{
										content1: "旅客自愿变更客票或者自愿退票的，承运人或者其航空销售代理人应当按照所适用的运输总条件、客票使用条件办理。"
									},

								],
							},

							{
								list: [{
										content1: " 由于承运人原因导致旅客非自愿变更客票的，承运人或者其航空销售代理人应当在有可利用座位或者被签转承运人同意的情况下，为旅客办理改期或者签转，不得向旅客收取客票变更费。"
									},
									{
										content1: "由于非承运人原因导致旅客非自愿变更客票的，承运人或者其航空销售代理人应当按照所适用的运输总条件、客票使用条件办理。"
									},
								],
							},

							{
								list: [{
									content1: "承运人或者其航空销售代理人应当在收到旅客有效退款申请之日起 7 个工作日内办理完成退款手续，上述时间不含金融机构处理时间。"
								}],
							},
							{
								list: [{
										content1: "在联程航班中，因其中一个或者几个航段变更，导致旅客无法按照约定时间完成整个行程的，缔约承运人或者其航空销售代理人应当协助旅客到达最终目的地或者中途分程地"
									},
									{
										content1: "在联程航班中，旅客非自愿变更客票的，按照本规定第二十四条办理；旅客非自愿退票的，按照本规定第二十五条办理"
									}
								],
							},

						],

					},
					{
						name: "第五章  乘   机",
						chapter: [{
								list: [{
									content1: "机场管理机构应当在办理乘机登记手续、行李托运、安检、海关、边检、登机口、中转通道等旅客乘机流程的关键区域设置标志标识指引，确保标志标识清晰、准确。"
								}, ],
							},
							{
								list: [{
										content1: "旅客在承运人或者其地面服务代理人停止办理乘机登记手续前，凭与购票时一致的有效身份证件办理客票查验、托运行李、获取纸质或者电子登机凭证。"
									},

								],
							},

							{
								list: [{
										content1: " 旅客在办理乘机登记手续时，承运人或者其地面服务代理人应当将旅客姓名、航班号、乘机日期、登机时间、登机口、航程等已确定信息准确、清晰地显示在纸质或者电子登机凭证上。"
									},
									{
										content1: "登机口、登机时间等发生变更的，承运人、地面服务代理人、机场管理机构应当及时告知旅客。 "
									},
								],
							},

							{
								list: [{
									content1: "有下列情况之一的，承运人应当拒绝运输： （一）依据国家有关规定禁止运输的旅客或者物品； （二）拒绝接受安全检查的旅客； （三）未经安全检查的行李； （四）办理乘机登记手续时出具的身份证件与购票时身份证件不一致的旅客； （五）国家规定的其他情况。 除前款规定外，旅客的行为有可能危及飞行安全或者公共秩序的，承运人有权拒绝运输。"
								}],
							},
							{
								list: [{
									content1: "旅客因本规定第三十一条被拒绝运输而要求出具书面说明的，除国家另有规定外，承运人应当及时出具；旅客要求变更客票或者退票的，承运人可以按照所适用的运输总条件、客票使用条件办理。"
								}, ],
							},
							{
								list: [{
									content1: "承运人、机场管理机构应当针对旅客突发疾病、意外伤害等对旅客健康情况产生重大影响的情形，制定应急处置预案。"
								}, ],
							},
							{
								list: [{
									content1: "因承运人原因导致旅客误机、错乘、漏乘的，承运人或者其航空销售代理人应当按照本规定第二十四条第一款、第二十五条办理客票变更或者退票。"
								}, {
									content1: "因非承运人原因导致前款规定情形的，承运人或者其航空销售代理人可以按照本规定第二十三条办理客票变更或者退票"
								}, ],
							},
						],

					},
					{
						name: "第六章  行李运输",
						chapter: [{
								list: [{
									content1: "承运人、地面服务代理人、机场管理机构应当建立托运行李监控制度，防止行李在运送过程中延误、破损、丢失等情况发生。"
								}, {
									content1: "承运人、机场管理机构应当积极探索行李跟踪等新技术应用，建立旅客托运行李全流程跟踪机制。"
								}, ],
							},
							{
								list: [{
										content1: " 旅客的托运行李、非托运行李不得违反国家禁止运输或者限制运输的相关规定。"
									}, {
										content1: " 在收运行李时或者运输过程中，发现行李中装有不得作为行李运输的任何物品，承运人应当拒绝收运或者终止运输，并通知旅客。"
									},

								],
							},

							{
								list: [{
									content1: "承运人应当在运输总条件中明确行李运输相关规定，至少包括下列内容： （一）托运行李和非托运行李的尺寸、重量以及数量要求； （二）免费行李额； （三）超限行李费计算方式； （四）是否提供行李声明价值服务，或者为旅客办理行李声明价值的相关要求； （五）是否承运小动物，或者运输小动物的种类及相关要求； （六）特殊行李的相关规定； （七）行李损坏、丢失、延误的赔偿标准或者所适用的国家有关规定、国际公约"
								}, ],
							},

							{
								list: [{
									content1: "承运人或者其地面服务代理人应当在收运行李后向旅客出具纸质或者电子行李凭证。"
								}],
							},
							{
								list: [{
									content1: "承运人应当将旅客的托运行李与旅客同机运送。 除国家另有规定外，不能同机运送的，承运人应当优先安排该行李在后续的航班上运送，并及时通知旅客。"
								}, ],
							},
							{
								list: [{
									content1: "旅客的托运行李延误到达的，承运人应当及时通知旅客领取。 除国家另有规定外，由于非旅客原因导致托运行李延误到达，旅客要求直接送达的，承运人应当免费将托运行李直接送达旅客或者与旅客协商解决方案。"
								}, ],
							},
							{
								list: [{
									content1: "在行李运输过程中，托运行李发生延误、丢失或者损坏，旅客要求出具行李运输事故凭证的，承运人或者其地面服务代理人应当及时提供。"
								}],
							},
						],

					},
					{
						name: "第七章  航班超售 ",
						chapter: [{
								list: [{
									content1: "承运人超售客票的，应当在超售前充分考虑航线、航班班次、时间、机型以及衔接航班等情况，最大程度避免旅客因超售被拒绝登机"
								}, ],
							},
							{
								list: [{
										content1: " 承运人应当在运输总条件中明确超售处置相关规定，至少包括下列内容： （一）超售信息告知规定； （二）征集自愿者程序； （三）优先登机规则； （四）被拒绝登机旅客赔偿标准、方式和相关服务标准"
									},

								],
							},

							{
								list: [{
									content1: "因承运人超售导致实际乘机旅客人数超过座位数时，承运人或者其地面服务代理人应当根据征集自愿者程序，寻找自愿放弃行程的旅客。 未经征集自愿者程序，不得使用优先登机规则确定被拒绝登机的旅客。"
								}, ],
							},

							{
								list: [{
									content1: "在征集自愿者时，承运人或者其地面服务代理人应当与旅客协商自愿放弃行程的条件"
								}],
							},
							{
								list: [{
									content1: "承运人的优先登机规则应当符合公序良俗原则，考虑的因素至少应当包括老幼病残孕等特殊旅客的需求、后续航班衔接等。 承运人或者其地面服务代理人应当在经征集自愿者程序未能寻找到足够的自愿者后，方可根据优先登机规则确定被拒绝登机的旅客"
								}, ],
							},
							{
								list: [{
									content1: "承运人或者其地面服务代理人应当按照超售处置规定向被拒绝登机旅客给予赔偿，并提供相关服务。"
								}, ],
							},
							{
								list: [{
									content1: "旅客因超售自愿放弃行程或者被拒绝登机时，承运人或者其地面服务代理人应当根据旅客的要求，出具因超售而放弃行程或者被拒绝登机的证明。"
								}],
							},
							{
								list: [{
									content1: "因超售导致旅客自愿放弃行程或者被拒绝登机的，承运人应当按照本规定第二十四条第一款、第二十五条办理客票变更或者退票。"
								}],
							},
						],

					},
					{
						name: "第八章  旅客投诉",
						chapter: [{
								list: [{
									content1: "因公共航空运输旅客服务发生争议的，旅客可以向承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者投诉，也可以向民航行政机关投诉。"
								}, ],
							},
							{
								list: [{
										content1: " 承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者应当设置电子邮件地址、中华人民共和国境内的投诉受理电话等投诉渠道，并向社会公布。"
									},
									{
										content1: "承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者应当设立专门机构或者指定专人负责受理投诉工作。"
									},
									{
										content1: "港澳台地区承运人和外国承运人应当具备以中文受理和处理投诉的能力。"
									},

								],
							},

							{
								list: [{
									content1: "承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者收到旅客投诉后，应当及时受理；不予受理的，应当说明理由。"
								}, {
									content1: "承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者应当在收到旅客投诉之日起10 个工作日内做出包含解决方案的处理结果。"
								}, {
									content1: "承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者应当书面记录旅客的投诉情况及处理结果，投诉记录至少保存 3 年。"
								}, ],
							},

							{
								list: [{
									content1: "民航局消费者事务中心受民航局委托统一受理旅客向民航行政机关的投诉。"
								}, {
									content1: "民航局消费者事务中心应当建立、畅通民航服务质量监督平台和民航服务质量监督电话等投诉渠道，实现全国投诉信息一体化。 "
								}, {
									content1: "旅客向民航行政机关投诉的，民航局消费者事务中心、承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者应当在民航服务质量监督平台上进行投诉处理工作 "
								}, ]
							},

						],

					},
					{
						name: "第九章  信息报告",
						chapter: [{
								list: [{
									content1: "承运人应当将运输总条件通过民航服务质量监督平台进行备案。 运输总条件发生变更的，应当自变更之日起 5 个工作日内在民航服务质量监督平台上更新备案。 备案的运输总条件应当与对外公布的运输总条件保持一致。"
								}, ],
							},
							{
								list: [{
										content1: " 承运人应当将其地面服务代理人、航空销售代理人的相关信息通过民航服务质量监督平台进行备案"
									},
									{
										content1: "前款所述信息发生变更的，应当自变更之日起 5 个工作日内在民航服务质量监督平台上更新备案。"
									},


								],
							},

							{
								list: [{
									content1: "承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者应当将投诉受理电话、电子邮件地址、投诉受理机构等信息通过民航服务质量监督平台进行备案。"
								}, {
									content1: "前款所述信息发生变更的，应当自变更之日起 5 个工作日内在民航服务质量监督平台上更新备案。"
								}],
							},

							{
								list: [{
									content1: "承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者、航空信息企业等相关单位，应当按照民航行政机关要求报送旅客运输服务有关数据和信息，并对真实性负责。"
								}, ]
							},

						],

					},
					{
						name: "第十章  监督管理及法律责任",
						chapter: [{
								list: [{
									content1: "有下列行为之一的，由民航行政机关责令限期改正；逾期未改正的，依法记入民航行业严重失信行为信用记录： （一）承运人违反本规定第六条、第七条、第八条，未按照要求制定、修改、适用或者公布运输总条件的； （二）承运人或者其地面服务代理人违反本规定第四十四条、第四十五条、第四十六条第二款、第四十七条，未按照要求为旅客提供超售后的服务的； （三）承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者违反本规定第五十一条第一款、第二款，第五十二条第一款、第二款，未按照要求开展投诉受理或者处理工作的。 "
								}, ],
							},
							{
								list: [{
										content1: "相关服务规定的； （三）航空信息企业违反本规定第十三条，未按照要求完善信息系统功能的； （四）承运人或者其航空销售代理人违反本规定第十九条，未按照要求录入旅客信息的； （五）承运人、航空销售代理人、航空信息企业违反本规定第二十一条，未按照要求保存相关信息的； （六）承运人违反本规定第三十二条，未按照要求出具被拒绝运输书面说明的； （七）承运人、机场管理机构违反本规定第三十三条，未按照要求制定应急处置预案的； （八）承运人、地面服务代理人、机场管理机构违反本规定第三十五条第一款，未按照要求建立托运行李监控制度的； （九）承运人或者其地面服务代理人违反本规定第四十一条，未按照要求提供行李运输事故凭证的； （十）承运人或者其地面服务代理人违反本规定第四十八条，未按照要求出具相关证明的； （十一）港澳台地区承运人和外国承运人违反本规定第五十一条第三款，未按照要求具备以中文受理和处理投诉能力的； （十二）承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者违反本规定第五十二条第三款，未按照要求保存投诉记录的； （十三）承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者违反本规定第五十三条第三款，未按照要求在民航服务质量监督平台上处理投诉的； （十四）承运人违反本规定第五十四条、第五十五条，未按照要求将运输总条件、地面服务代理人、航空销售代理人的相关信息备案的； （十五）承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者违反本规定第五十六条，未按照要求将投诉相关信息备案的； （十六）承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者违反本规定第五十七条，未按照要求报送相关数据和信息的"
									},



								],
							},

							{
								list: [{
									content1: "航空销售网络平台经营者有本规定第十条第一款规定的行为，构成《中华人民共和国电子商务法》规定的不履行核验义务的，依照《中华人民共和国电子商务法》的规定执行。"
								}],
							},

							{
								list: [{
									content1: "承运人、机场管理机构、地面服务代理人、航空销售代理人、航空销售网络平台经营者、航空信息企业违反本规定第十四条，侵害旅客个人信息，构成《中华人民共和国消费者权益保护法》规定的侵害消费者个人信息依法得到保护的权利的，依照《中华人民共和国消费者权益保护法》的规定执行。 承运人或者其航空销售代理人违反本规定第二十三条、 第二十四条、第二十五条、第二十六条、第二十七条，未按照要求办理客票变更、退票或者未履行协助义务，构成《中华人民共和国消费者权益保护法》规定的故意拖延或者无理拒绝消费者提出的更换、退还服务费用要求的，依照《中华人民共和国消费者权益保护法》的规定执行。"
								}, ]
							},
							{
								list: [{
									content1: "机场管理机构违反本规定第二十八条，未按照要求设置标志标识，构成《民用机场管理条例》规定的未按照国家规定的标准配备相应设施设备的，依照《民用机场管理条例》的规定执行。"
								}],
							},

						],

					},
					{
						name: "第十一章  附   则",
						chapter: [{
								list: [{
									content1: "（十七）非自愿变更客票，指因航班取消、延误、提前、航程改变、舱位等级变更或者承运人无法运行原航班等情形，导致旅客变更客票的情形。 （十八）承运人原因，是指承运人内部管理原因，包括机务维护、航班调配、机组调配等。 （十九）非承运人原因，是指与承运人内部管理无关的其他原因，包括天气、突发事件、空中交通管制、安检、旅客等因素。 （二十）行李，是指承运人同意运输的、旅客在旅行中携带的物品，包括托运行李和非托运行李。 （二十一）托运行李，是指旅客交由承运人负责照管和运输并出具行李运输凭证的行李。 （二十二）非托运行李，是指旅客自行负责照管的行李。 （二十三）票价，是指承运人使用民用航空器将旅客由出发地机场运送至目的地机场的航空运输服务的价格，不包含按照国家规定收取的税费。 （二十四）计划出港时间，是指航班时刻管理部门批准的离港时间。 （二十五）计划到港时间，是指航班时刻管理部门批准的到港时间。 （二十六）客票使用条件，是指定座舱位代码或者票价种类所适用的票价规则。 （二十七）客票改期，是指客票列明同一承运人的航班时刻、航班日期的变更。（二十八）签转，是指客票列明承运人的变更。 （二十九）联程航班，是指被列明在单一运输合同中的两个（含）以上的航班。 （三十）误机，是指旅客未按规定时间办妥乘机手续或者因身份证件不符合规定而未能乘机。 （三十一）错乘，是指旅客搭乘了不是其客票列明的航班。 （三十二）漏乘，是指旅客办妥乘机手续后或者在经停站过站时未能搭乘其客票列明的航班。 （三十三）小动物，是指旅客托运的小型动物，包括家庭饲养的猫、狗或者其他类别的小动物。 （三十四）超售，是指承运人为避免座位虚耗，在某一航班上销售座位数超过实际可利用座位数的行为。 （三十五）经停地点，是指除出发地点和目的地点以外，作为旅客旅行路线上预定经停的地点。 （三十六）中途分程地，是指经承运人事先同意，旅客在出发地和目的地间旅行时有意安排在某个地点的旅程间断。"
								}, ],
							},
							{
								list: [{
										content1: "本规定以工作日计算的时限均不包括当日，从次日起计算。"
									},

								],
							},

							{
								list: [{
									content1: "本规定自 2021 年 9 月 1 日起施行。原民航总局于 1996 年 2 月 28 日公布的《中国民用航空旅客、行李国内运输规则》（民航总局令第 49 号 ）、 2004 年 7 月 12 日公布的《中国民用航空总局关于修订〈中国民用航空旅客、  行李国内运输规则〉的决定》（民航总局令第 124 号 ）和 1997年 12 月 8 日公布的《中国民用航空旅客、行李国际运输规则》（民航总局令第 70 号）同时废止。 本规定施行前公布的涉及民航管理的规章中关于客票变更、退票以及旅客投诉管理的内容与本规定不一致的，按照本规定执行。"
								}],
							},
						],

					},

				],

				aboutList3: [{
						name: "第一章 总 则",
						chapter: [{
								list: [{
										content1: "为了防止对民用航空活动的非法干扰，维护民用航空秩序，保障民用航空安全，制定本条例。"
									},

								],
							},
							{
								list: [{
										content1: "本条例适用于在中华人民共和国领域内的一切民用航空活动以及与民用航空活动有关的单位和个人。在中华人民共和国领域外从事民用航空活动的具有中华人民共和国国籍的民用航空器适用本条例；但是，中华人民共和国缔结或者参加的国际条约另有规定的除外。"
									},

								],
							},
							{
								list: [{
										content1: "民用航空安全保卫工作实行统一管理、分工负责的原则。民用航空公安机关（以下简称民航公安机关）负责对民用航空安全保卫工作实施统一管理、检查和监督。"
									},

								],
							},
							{
								list: [{
										content1: "有关地方人民政府与民用航空单位应当密切配合，共同维护民用航空安全。"
									},

								],
							},
							{
								list: [{
										content1: "旅客、货物托运人和收货人以及其他进入机场的人员，应当遵守民用航空安全管理的法律、法规和规章。"
									},

								],
							},
							{
								list: [{
										content1: "民用机场经营人和民用航空器经营人应当履行下列职责：（一）制定本单位民用航空安全保卫方案，并报国务院民用航空主管部门备案；（二）严格实行有关民用航空安全保卫的措施；（三）定期进行民用航空安全保卫训练，及时消除危及民用航空安全的隐患。与中华人民共和国通航的外国民用航空企业，应当向国务院民用航空主管部门报送民用航空安全保卫方案。"
									},

								],
							},
							{
								list: [{
										content1: "公民有权向民航公安机关举报预谋劫持、破坏民用航空器或者其他危害民用航空安全的行为。"
									},

								],
							},
							{
								list: [{
										content1: "对维护民用航空安全做出突出贡献的单位或者个人，由有关人民政府或者国务院民用航空主管部门给予奖励。"
									},

								],
							},

						],

					},
					{
						name: "第二章 民用机场的安全保卫",
						chapter: [{
								list: [{
										content1: "民用机场（包括军民合用机场中的民用部分，下同）的新建、改建或者扩建，应当符合国务院民用航空主管部门关于民用机场安全保卫设施建设的规定。"
									},

								],
							},
							{
								list: [{
										content1: "民用机场开放使用，应当具备下列安全保卫条件：（一）设有机场控制区并配备专职警卫人员；（二）设有符合标准的防护围栏和巡逻通道；（三）设有安全保卫机构并配备相应的人员和装备；（四）设有安全检查机构并配备与机场运输量相适应的人员和检查设备；（五）设有专职消防组织并按照机场消防等级配备人员和设备；（六）订有应急处置方案并配备必要的应急援救设备。"
									},

								],
							},

							{
								list: [{
									content1: "机场控制区应当根据安全保卫的需要，划定为候机隔离区、行李分检装卸区、航空器活动区和维修区、货物存放区等，并分别设置安全防护设施和明显标志。"
								}, ],
							},

							{
								list: [{
										content1: "机场控制区应当有严密的安全保卫措施，实行封闭式分区管理。具体管理办法由国务院民用航空主管部门制定。"
									},

								],
							},
							{
								list: [{
									content1: "人员与车辆进入机场控制区，必须佩带机场控制区通行证并接受警卫人员的检查。机场控制区通行证，由民航公安机关按照国务院民用航空主管部门的有关规定制发和管理。"
								}, ],
							},
							{
								list: [{
									content1: "在航空器活动区和维修区内的人员、车辆必须按照规定路线行进，车辆、设备必须在指定位置停放，一切人员、车辆必须避让航空器。"
								}],
							},
							{
								list: [{
									content1: "停放在机场的民用航空器必须有专人警卫；各有关部门及其工作人员必须严格执行航空器警卫交接制度。"
								}, ],
							},
							{
								list: [{
									content1: "机场内禁止下列行为：（一）攀（钻）越、损毁机场防护围栏及其他安全防护设施；（二）在机场控制区内狩猎、放牧、晾晒谷物、教练驾驶车辆；（三）无机场控制区通行证进入机场控制区；（四）随意穿越航空器跑道、滑行道；（五）强行登、占航空器；（六）谎报险情，制造混乱；（七）扰乱机场秩序的其他行为。"
								}, ],
							},

						],

					},
					{
						name: "第三章 民用航空营运的安全保卫",
						chapter: [



							{
								list: [{
									content1: "承运人及其代理人出售客票、必须符合国务院民用航空主管部门的有关规定；对不符合规定的，不得售予客票。"
								}],
							},
							{
								list: [{
									content1: "承运人办理承运手续时，必须核对乘机人和行李。"
								}],
							},

							{
								list: [{
									content1: "旅客登机时，承运人必须核对旅客人数。对已经办理登机手续而未登机的旅客的行李，不得装入或者留在航空器内。旅客在航空器飞行中途中止旅行时，必须将其行李卸下。"
								}, ],
							},

							{
								list: [{
									content1: "承运人对承运的行李、货物，在地面存储和运输期间，必须有专人监管。"
								}, ],
							},
							{
								list: [{
									content1: "配制、装载供应品的单位对装入航空器的供应品，必须保证其安全性。"
								}, ],
							},
							{
								list: [{
									content1: "航空器在飞行中的安全保卫工作由机长统一负责。航空安全员在机长领导下，承担安全保卫的具体工作。机长、航空安全员和机组其他成员，应当严格履行职责，保护民用航空器及其所载人员和财产的安全。"
								}, ],
							},
							{
								list: [{
									content1: "机长在执行职务时，可以行使下列权力：（一）在航空器起飞前，发现有关方面对航空器未采取本条例规定的安全措施的，拒绝起飞；（二）在航空器飞行中，对扰乱航空器内秩序，干扰机组人员正常工作而不听劝阻的人，采取必要的管束措施；（三）在航空器飞行中，对劫持、破坏航空器或者其他危及安全的行为，采取必要的措施；（四）在航空器飞行中遇到特殊情况时，对航空器的处置作最后决定。"
								}, ],
							},
							{
								list: [{
									content1: "禁止下列扰乱民用航空营运秩序的行为：（一）倒卖购票证件、客票和航空运输企业的有效订座凭证；（二）冒用他人身份证件购票、登机；（三）利用客票交运或者捎带非旅客本人的行李物品；（四）将未经安全检查或者采取其他安全措施的物品装入航空器。"
								}, ],
							},
							{
								list: [{
									content1: "航空器内禁止下列行为：（一）在禁烟区吸烟；（二）抢占座位、行李舱（架）；（三）打架、酗酒、寻衅滋事；（四）盗窃、故意损坏或者擅自移动救生物品和设备；（五）危及飞行安全和扰乱航空器内秩序的其他行为。"
								}, ],
							},
						],

					},
					{
						name: "第四章 安全检查",
						chapter: [{
								list: [{
									content1: "违反本条例第十四条的规定或者有本条例第十六条、第二十四条第一项和第二项、第二十五条所列行为的，由民航公安机关依照《中华人民共和国治安管理处罚条例》有关规定予以处罚。"
								}, ],
							},
							{
								list: [{
									content1: "违反本条例的有关规定，由民航公安机关按照下列规定予以处罚：（一）有本条例第二十四条第四项所列行为的，可以处以警告或者 3000 元以下的罚款；（二）有本条例第二十四条第三项所列行为的，可以处以警告、没收非法所得或者 5000元以下罚款；（三）违反本条例第三十条第二款、第三十二条的规定，尚未构成犯罪的，可以处以5000 元以下罚款、没收或者扣留非法携带的物品。"
								}, ],
							},
							{
								list: [{
									content1: "违反本条例的规定，有下列情形之一的，民用航空主管部门可以对有关单位处以警告、停业整顿或者 5 万元以下的罚款；民航公安机关可以对直接责任人员处以警告或者 500 元以下的罚款：（一）违反本条例第十五条的规定，造成航空器失控的；（二）违反本条例第十七条的规定，出售客票的；（三）违反本条例第十八条的规定，承运人办理承运手续时，不核对乘机人和行李的；（四）违反本条例第十九条的规定的；（五）违反本条例第二十条、第二十一条、第三十条第一款、第三十一条的规定，对收运、装入航空器的物品不采取安全措施的。"
								}, ],
							},
							{
								list: [{
									content1: "违反本条例的有关规定，构成犯罪的，依法追究刑事责任。"
								}, ],
							},
							{
								list: [{
									content1: "违反本条例规定的，除依照本章的规定予以处罚外，给单位或者个人造成财产损失的，应当依法承担赔偿责任。"
								}, ],
							},






						],

					},
					{
						name: "第六章 附 则",
						chapter: [{
								list: [{
									content1: "本条例下列用语的含义：“机场控制区”，是指根据安全需要在机场内划定的进出受到限制的区域。“候机隔离区”，是指根据安全需要在候机楼（室）内划定的供已经安全检查的出港旅客等待登机的区域及登机通道、摆渡车。“航空器活动区”，是指机场内用于航空器起飞、着陆以及与此有关的地面活动区域，包括跑道、滑行道、联络道、客机坪。"
								}, ],
							},
							{
								list: [{
									content1: "本条例自发布之日起施行。"
								}, ],
							},

						],

					},

				],
				aboutList4: [{
						name: "第一章 总 则",
						chapter: [{
								list: [{
										content1: "为了维护国家的领空主权和民用航空权利，保障民用航空活动安全和有秩序地进行，保护民用航空活动当事人各方的合法权益，促进民用航空事业的发展，制定本法。"
									},

								],
							},
							{
								list: [{
										content1: "中华人民共和国的领陆和领水之上的空域为中华人民共和国领空。中华人民共和国对领空享有完全的、排他的主权。"
									},

								],
							},

							{
								list: [{
										content1: "国务院民用航空主管部门对全国民用航空活动实施统一监督管理；根据法律和国务院的决定，在本部门的权限内，发布有关民用航空活动的规定、决定。国务院民用航空主管部门设立的地区民用航空管理机构依照国务院民用航空主管部门的授权，监督管理各该地区的民用航空活动。"
									},

								],
							},
							{
								list: [{
										content1: "国家扶持民用航空事业的发展，鼓励和支持发展民用航空的科学研究和教育事业，提高民用航空科学技术水平。国家扶持民用航空器制造业的发展，为民用航空活动提供安全、先进、经济、适用的民用航空器。"
									},

								],
							},

						],

					},
					{
						name: "第二章 民用航空器国籍",
						chapter: [{
								list: [{
										content1: "本法所称民用航空器，是指除用于执行军事、海关、警察飞行任务外的航空器。"
									},

								],
							},



							{
								list: [{
										content1: "经中华人民共和国国务院民用航空主管部门依法进行国籍登记的民用航空器，具有中华人民共和国国籍，由国务院民用航空主管部门发给国籍登记证书。国务院民用航空主管部门设立中华人民共和国民用航空器国籍登记簿，统一记载民用航空器的国籍登记事项。"
									},

								],
							},

							{
								list: [{
									content1: "下列民用航空器应当进行中华人民共和国国籍登记(一)中华人民共和国国家机构的民用航空器；(二)依照中华人民共和国法律设立的企业法人的民用航空器；企业法人的注册资本中有外商出资的，其机构设置、人员组成和中方投资人的出资比例，应当符合行政法规的规定；(三)国务院民用航空主管部门准予登记的其他民用航空器。自境外租赁的民用航空器，承租人符合前款规定，该民用航空器的机组人员由承租人配备的，可以申请登记中华人民共和国国籍，但是必须先予注销该民用航空器原国籍登记。"
								}],
							},
							{
								list: [{
									content1: "依法取得中华人民共和国国籍的民用航空器，应当标明规定的国籍标志和登记标志。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器不得具有双重国籍。未注销外国国籍的民用航空器不得在中华人民共和国申请国籍登记。"
								}, ],
							},

						],

					},
					{
						name: "第三章 民用航空器权利",
						chapter: [



							{
								list: [{
									content1: "本章规定的对民用航空器的权利，包括对民用航空器构架、发动机、螺旋桨、无线电设备和其他一切为了在民用航空器上使用的，无论安装于其上或者暂时拆离的物品的权利。"
								}],
							},
							{
								list: [{
									content1: "民用航空器权利人应当就下列权利分别向国务院民用航空主管部门办理权利登记：(一)民用航空器所有权；(二)通过购买行为取得并占有民用航空器的权利；(三)根据租赁期限为六个月以上的租赁合同占有民用航空器的权利；(四)民用航空器抵押权。"
								}],
							},

							{
								list: [{
									content1: "国务院民用航空主管部门设立民用航空器权利登记簿。同一民用航空器的权利登记事项应当记载于同一权利登记簿中。民用航空器权利登记事项，可以供公众查询、复制或者摘录。"
								}, ],
							},

							{
								list: [{
									content1: "除民用航空器经依法强制拍卖外，在已经登记的民用航空器权利得到补偿或者民用航空器权利人同意之前，民用航空器的国籍登记或者权利登记不得转移至国外。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器所有权的取得、转让和消灭，应当向国务院民用航空主管部门登记；未经登记的，不得对抗第三人。民用航空器所有权的转让，应当签订书面合同。"
								}, ],
							},
							{
								list: [{
									content1: "国家所有的民用航空器，由国家授予法人经营管理或者使用的，本法有关民用航空器所有人的规定适用于该法人。"
								}, ],
							},
							{
								list: [{
									content1: "设定民用航空器抵押权，由抵押权人和抵押人共同向国务院民用航空主管部门办理抵押权登记；未经登记的，不得对抗第三人。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器抵押权设定后，未经抵押权人同意，抵押人不得将被抵押民用航空器转让他人。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器优先权，是指债权人依照本法第十九条规定，向民用航空器所有人、承租人提出赔偿请求，对产生该赔偿请求的民用航空器具有优先受偿的权利。"
								}, ],
							},
							{
								list: [{
									content1: "下列各项债权具有民用航空器优先权：(一)援救该民用航空器的报酬；(二)保管维护该民用航空器的必需费用。前款规定的各项债权，后发生的先受偿。"
								}, ],
							},
							{
								list: [{
									content1: "本法第十九条规定的民用航空器优先权，其债权人应当自援救或者保管维护工作终了之日起三个月内，就其债权向国务院民用航空主管部门登记。"
								}, ],
							},
							{
								list: [{
									content1: "为了债权人的共同利益，在执行人民法院判决以及拍卖过程中产生的费用，应当从民用航空器拍卖所得价款中先行拨付。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器优先权先于民用航空器抵押权受偿。"
								}, ],
							},
							{
								list: [{
									content1: "本法第十九条规定的债权转移的，其民用航空器优先权随之转移。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器优先权应当通过人民法院扣押产生优先权的民用航空器行使。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器优先权自援救或者保管维护工作终了之日起满三个月时终止；但是，债权人就其债权已经依照本法第二十条规定登记，并具有下列情形之一的除外：(一)债权人、债务人已经就此项债权的金额达成协议；(二)有关此项债权的诉讼已经开始。民用航空器优先权不因民用航空器所有权的转让而消灭；但是，民用航空器经依法强制拍卖的除外。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器租赁合同，包括融资租赁合同和其他租赁合同，应当以书面形式订立。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器的融资租赁，是指出租人按照承租人对供货方和民用航空器的选择，购得民用航空器，出租给承租人使用，由承租人定期交纳租金。"
								}, ],
							},
							{
								list: [{
									content1: "融资租赁期间，出租人依法享有民用航空器所有权，承租人依法享有民用航空器的占有、使用、收益权。"
								}, ],
							},
							{
								list: [{
									content1: "融资租赁期间，出租人不得干扰承租人依法占有、使用民用航空器；承租人应当适当地保管民用航空器， 使之处于原交付时的状态， 但是合理损耗和经出租人同意的对民用航空器的改变除外。 "
								}, ],
							},
							{
								list: [{
									content1: "融资租赁期满，承租人应当将符合本法第二十九条规定状态的民用航空器退还出租人；但是，承租人依照合同行使购买民用航空器的权利或者为继续租赁而占有民用航空器的除外。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器融资租赁中的供货方，不就同一损害同时对出租人和承租人承担责任。"
								}, ],
							},
							{
								list: [{
									content1: "融资租赁期间，经出租人同意，在不损害第三人利益的情况下，承租人可以转让其对民用航空器的占有权或者租赁合同约定的其他权利。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器的融资租赁和租赁期限为六个月以上的其他租赁，承租人应当就其对民用航空器的占有权向国务院民用航空主管部门办理登记；未经登记的，不得对抗第三人。"
								}, ],
							},


						],

					},
					{
						name: "第四章 民用航空器适航管理",
						chapter: [{
								list: [{
									content1: "设计民用航空器及其发动机、螺旋桨和民用航空器上设备，应当向国务院民用航空主管部门申请领取型号合格证书。经审查合格的，发给型号合格证书。"
								}, ],
							},
							{
								list: [{
									content1: "生产、维修民用航空器及其发动机、螺旋桨和民用航空器上设备，应当向国务院民用航空主管部门申请领取生产许可证书、维修许可证书。经审查合格的，发给相应的证书。"
								}, ],
							},

							{
								list: [{
									content1: "外国制造人生产的任何型号的民用航空器及其发动机、螺旋桨和民用航空器上设备，首次进口中国的，该外国制造人应当向国务院民用航空主管部门申请领取型号认可证书。经审查合格的，发给型号认可证书。已取得外国颁发的型号合格证书的民用航空器及其发动机、螺旋桨和民用航空器上设备，首次在中国境内生产的，该型号合格证书的持有人应当向国务院民用航空主管部门申请领取型号认可证书。经审查合格的，发给型号认可证书。"
								}, ],
							},
							{
								list: [{
									content1: "具有中华人民共和国国籍的民用航空器，应当持有国务院民用航空主管部门颁发的适航证书，方可飞行。出口民用航空器及其发动机、螺旋桨和民用航空器上设备，制造人应当向国务院民用航空主管部门申请领取出口适航证书。经审查合格的，发给出口适航证书。租用的外国民用航空器，应当经国务院民用航空主管部门对其原国籍登记国发给的适航证书审查认可或者另发适航证书，方可飞行。民用航空器适航管理规定，由国务院制定。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器的所有人或者承租人应当按照适航证书规定的使用范围使用民用航空器，做好民用航空器的维修保养工作，保证民用航空器处于适航状态。"
								}, ],
							},
						],

					},
					{
						name: "第五章 航空人员",
						chapter: [{
								list: [{
									content1: "本法所称航空人员，是指下列从事民用航空活动的空勤人员和地面人员：(一)空勤人员，包括驾驶员、领航员、飞行机械人员、飞行通信员、乘务员；(二)地面人员，包括民用航空器维修人员、空中交通管制员、飞行签派员、航空电台通信员。"
								}, ],
							},
							{
								list: [{
									content1: "航空人员应当接受专门训练，经考核合格，取得国务院民用航空主管部门颁发的执照，方可担任其执照载明的工作。空勤人员和空中交通管制员在取得执照前，还应当接受国务院民用航空主管部门认可的体格检查单位的检查，并取得国务院民用航空主管部门颁发的体格检查合格证书。"
								}, ],
							},
							{
								list: [{
									content1: "空勤人员在执行飞行任务时，应当随身携带执照和体格检查合格证书，并接受国务院民用航空主管部门的查验。"
								}, ],
							},
							{
								list: [{
									content1: "航空人员应当接受国务院民用航空主管部门定期或者不定期的检查和考核；经检查、考核合格的，方可继续担任其执照载明的工作。空勤人员还应当参加定期的紧急程序训练。空勤人员间断飞行的时间超过国务院民用航空主管部门规定时限的，应当经过检查和考核；乘务员以外的空勤人员还应当经过带飞。经检查、考核、带飞合格的，方可继续担任其执照载明的工作。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器机组由机长和其他空勤人员组成。机长应当由具有独立驾驶该型号民用航空器的技术和经验的驾驶员担任。机组的组成和人员数额，应当符合国务院民用航空主管部门的规定。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器的操作由机长负责，机长应当严格履行职责，保护民用航空器及其所载人员和财产的安全。机长在其职权范围内发布的命令，民用航空器所载人员都应当执行。"
								}, ],
							},
							{
								list: [{
									content1: "飞行前，机长应当对民用航空器实施必要的检查；未经检查，不得起飞。机长发现民用航空器、机场、气象条件等不符合规定，不能保证飞行安全的，有权拒绝起飞。"
								}, ],
							},
							{
								list: [{
									content1: "飞行中，对于任何破坏民用航空器、扰乱民用航空器内秩序、危害民用航空器所载人员或者财产安全以及其他危及飞行安全的行为，在保证安全的前提下，机长有权采取必要的适当措施。飞行中，遇到特殊情况时，为保证民用航空器及其所载人员的安全，机长有权对民用航空器作出处置。"
								}, ],
							},
							{
								list: [{
									content1: "机长发现机组人员不适宜执行飞行任务的，为保证飞行安全，有权提出调整。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器遇险时，机长有权采取一切必要措施，并指挥机组人员和航空器上其他人员采取抢救措施。在必须撤离遇险民用航空器的紧急情况下，机长必须采取措施，首先组织旅客安全离开民用航空器；未经机长允许，机组人员不得擅自离开民用航空器；机长应当最后离开民用航空器。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器发生事故，机长应当直接或者通过空中交通管制单位，如实将事故情况及时报告国务院民用航空主管部门。"
								}, ],
							},
							{
								list: [{
									content1: "机长收到船舶或者其他航空器的遇险信号，或者发现遇险的船舶、航空器及其人员，应当将遇险情况及时报告就近的空中交通管制单位并给予可能的合理的援助。"
								}, ],
							},
							{
								list: [{
									content1: "飞行中，机长因故不能履行职务的，由仅次于机长职务的驾驶员代理机长；在下一个经停地起飞前，民用航空器所有人或者承租人应当指派新机长接任。"
								}, ],
							},
							{
								list: [{
									content1: " 只有一名驾驶员，不需配备其他空勤人员的民用航空器，本节对机长的规定，适用于该驾驶员。"
								}, ],
							},

						],

					},
					{
						name: "第六章 民用机场",
						chapter: [{
								list: [{
										content1: "本法所称民用机场，是指专供民用航空器起飞、降落、滑行、停放以及进行其他活动使用的划定区域，包括附属的建筑物、装置和设施。本法所称民用机场不包括临时机场。军民合用机场由国务院、中央军事委员会另行制定管理办法。"
									},

								],
							},
							{
								list: [{
										content1: "民用机场的建设和使用应当统筹安排、合理布局，提高机场的使用效率。全国民用机场的布局和建设规划，由国务院民用航空主管部门会同国务院其他有关部门制定，并按照国家规定的程序，经批准后组织实施。省、自治区、直辖市人民政府应当根据全国民用机场的布局和建设规划，制定本行政区域内的民用机场建设规划，并按照国家规定的程序报经批准后，将其纳入本级国民经济和社会发展规划。"
									},

								],
							},
							{
								list: [{
									content1: "民用机场建设规划应当与城市建设规划相协调。"
								}, ],
							},
							{
								list: [{
									content1: "新建、改建和扩建民用机场，应当符合依法制定的民用机场布局和建设规划，符合民用机场标准，并按照国家规定报经有关主管机关批准并实施。不符合依法制定的民用机场布局和建设规划的民用机场建设项目，不得批准。"
								}, ],
							},
							{
								list: [{
									content1: "新建、扩建民用机场，应当由民用机场所在地县级以上地方人民政府发布公告。前款规定的公告应当在当地主要报纸上刊登，并在拟新建、扩建机场周围地区张贴。"
								}, ],
							},
							{
								list: [{
									content1: "禁止在依法划定的民用机场范围内和按照国家规定划定的机场净空保护区域内从事下列活动：(一)修建可能在空中排放大量烟雾、粉尘、火焰、废气而影响飞行安全的建筑物或者设施；(二)修建靶场、强烈爆炸物仓库等影响飞行安全的建筑物或者设施；(三)修建不符合机场净空要求的建筑物或者设施；(四)设置影响机场目视助航设施使用的灯光、标志或者物体；(五)种植影响飞行安全或者影响机场助航设施使用的植物；(六)饲养、放飞影响飞行安全的鸟类动物和其他物体；(七)修建影响机场电磁环境的建筑物或者设施。禁止在依法划定的民用机场范围内放养牲畜。"
								}, ],
							},
							{
								list: [{
									content1: "民用机场新建、扩建的公告发布前，在依法划定的民用机场范围内和按照国家规定划定的机场净空保护区域内存在的可能影响飞行安全的建筑物、构筑物、树木、灯光和其他障碍物体，应当在规定的期限内清除；对由此造成的损失，应当给予补偿或者依法采取其他补救措施。"
								}, ],
							},
							{
								list: [{
									content1: "民用机场新建、扩建的公告发布后，任何单位和个人违反本法和有关行政法规的规定，在依法划定的民用机场范围内和按照国家规定划定的机场净空保护区域内修建、种植或者设置影响飞行安全的建筑物、构筑物、树木、灯光和其他障碍物体的，由机场所在地县级以上地方人民政府责令清除；由此造成的损失，由修建、种植或者设置该障碍物体的人承担。"
								}, ],
							},
							{
								list: [{
									content1: "在民用机场及其按照国家规定划定的净空保护区域以外，对可能影响飞行安全的高大建筑物或者设施，应当按照国家有关规定设置飞行障碍灯和标志，并使其保持正常状态。"
								}, ],
							},
							{
								list: [{
									content1: "民用机场应当持有机场使用许可证，方可开放使用。民用机场具备下列条件，并按照国家规定经验收合格后，方可申请机场使用许可证：(一)具备与其运营业务相适应的飞行区、航站区、工作区以及服务设施和人员；(二)具备能够保障飞行安全的空中交通管制、通信导航、气象等设施和人员；(三)具备符合国家规定的安全保卫条件；(四)具备处理特殊情况的应急计划以及相应的设施和人员；(五)具备国务院民用航空主管部门规定的其他条件。国际机场还应当具备国际通航条件，设立海关和其他口岸检查机关。"
								}, ],
							},
							{
								list: [{
									content1: "民用机场使用许可证由机场管理机构向国务院民用航空主管部门申请，经国务院民用航空主管部门审查批准后颁发。"
								}, ],
							},
							{
								list: [{
									content1: "设立国际机场，由国务院民用航空主管部门报请国务院审查批准。国际机场的开放使用，由国务院民用航空主管部门对外公告；国际机场资料由国务院民用航空主管部门统一对外提供。"
								}, ],
							},
							{
								list: [{
									content1: "民用机场应当按照国务院民用航空主管部门的规定，采取措施，保证机场内人员和财产的安全。"
								}, ],
							},
							{
								list: [{
									content1: "供运输旅客或者货物的民用航空器使用的民用机场，应当按照国务院民用航空主管部门规定的标准，设置必要设施，为旅客和货物托运人、收货人提供良好服务。"
								}, ],
							},
							{
								list: [{
									content1: "民用机场管理机构应当依照环境保护法律、行政法规的规定，做好机场环境保护工作。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器使用民用机场及其助航设施的，应当缴纳使用费、服务费；使用费、服务费的收费标准，由国务院民用航空主管部门会同国务院财政部门、物价主管部门制定。"
								}, ],
							},
							{
								list: [{
									content1: "民用机场废弃或者改作他用，民用机场管理机构应当依照国家规定办理报批手续。"
								}, ],
							},




						],

					},
					{
						name: "第七章 空中航行",
						chapter: [{
								list: [{
										content1: "国家对空域实行统一管理。"
									},

								],
							},
							{
								list: [{
										content1: "划分空域，应当兼顾民用航空和国防安全的需要以及公众的利益，使空域得到合理、充分、有效的利用。"
									},

								],
							},
							{
								list: [{
									content1: "空域管理的具体办法，由国务院、中央军事委员会制定。"
								}, ],
							},
							{
								list: [{
									content1: "在一个划定的管制空域内，由一个空中交通管制单位负责该空域内的航空器的空中交通管制。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器在管制空域内进行飞行活动，应当取得空中交通管制单位的许可。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器应当按照空中交通管制单位指定的航路和飞行高度飞行；因故确需偏离指定的航路或者改变飞行高度飞行的，应当取得空中交通管制单位的许可。"
								}, ],
							},


							{
								list: [{
									content1: "在中华人民共和国境内飞行的航空器，必须遵守统一的飞行规则。进行目视飞行的民用航空器，应当遵守目视飞行规则，并与其他航空器、地面障碍物体保持安全距离。进行仪表飞行的民用航空器，应当遵守仪表飞行规则。飞行规则由国务院、中央军事委员会制定。"
								}, ],
							},

							{
								list: [{
									content1: "民用航空器机组人员的飞行时间、执勤时间不得超过国务院民用航空主管部门规定的时限。民用航空器机组人员受到酒类饮料、麻醉剂或者其他药物的影响，损及工作能力的，不得执行飞行任务。"
								}, ],
							},

							{
								list: [{
									content1: "民用航空器除按照国家规定经特别批准外，不得飞入禁区；除遵守规定的限制条件外，不得飞入限制区。前款规定的禁区和限制区，依照国家规定划定。"
								}, ],
							},

							{
								list: [{
									content1: "民用航空器不得飞越城市上空；但是，有下列情形之一的除外：(一)起飞、降落或者指定的航路所必需的；(二)飞行高度足以使该航空器在发生紧急情况时离开城市上空，而不致危及地面上的人员、财产安全的；(三)按照国家规定的程序获得批准的。"
								}, ],
							},
							{
								list: [{
									content1: "飞行中，民用航空器不得投掷物品；但是，有下列情形之一的除外：(一)飞行安全所必需的；(二)执行救助任务或者符合社会公共利益的其他飞行任务所必需的。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器未经批准不得飞出中华人民共和国领空。对未经批准正在飞离中华人民共和国领空的民用航空器，有关部门有权根据具体情况采取必要措施，予以制止。"
								}, ],
							},
							{
								list: [{
									content1: "空中交通管制单位应当为飞行中的民用航空器提供空中交通服务，包括空中交通管制服务、飞行情报服务和告警服务。提供空中交通管制服务，旨在防止民用航空器同航空器、民用航空器同障碍物体相撞，维持并加速空中交通的有秩序的活动。提供飞行情报服务，旨在提供有助于安全和有效地实施飞行的情报和建议。提供告警服务，旨在当民用航空器需要搜寻援救时，通知有关部门，并根据要求协助该有关部门进行搜寻援救。"
								}, ],
							},
							{
								list: [{
									content1: "空中交通管制单位发现民用航空器偏离指定航路、迷失航向时，应当迅速采取一切必要措施，使其回归航路。"
								}, ],
							},
							{
								list: [{
									content1: "航路上应当设置必要的导航、通信、气象和地面监视设备。"
								}, ],
							},
							{
								list: [{
									content1: "航路上影响飞行安全的自然障碍物体，应当在航图上标明；航路上影响飞行安全的人工障碍物体，应当设置飞行障碍灯和标志，并使其保持正常状态。"
								}, ],
							},
							{
								list: [{
									content1: "在距离航路边界 30 公里以内的地带，禁止修建靶场和其他可能影响飞行安全的设施；但是，平射轻武器靶场除外。在前款规定地带以外修建固定的或者临时性对空发射场，应当按照国家规定获得批准；对空发射场的发射方向，不得与航路交叉。"
								}, ],
							},
							{
								list: [{
									content1: "任何可能影响飞行安全的活动，应当依法获得批准，并采取确保飞行安全的必要措施，方可进行。"
								}, ],
							},
							{
								list: [{
									content1: "国务院民用航空主管部门应当依法对民用航空无线电台和分配给民用航空系统使用的专用频率实施管理。任何单位或者个人使用的无线电台和其他仪器、装置，不得妨碍民用航空无线电专用频率的正常使用。对民用航空无线电专用频率造成有害干扰的，有关单位或者个人应当迅速排除干扰；未排除干扰前，应当停止使用该无线电台或者其他仪器、装置。"
								}, ],
							},
							{
								list: [{
									content1: "邮电通信企业应当对民用航空电信传递优先提供服务。国家气象机构应当对民用航空气象机构提供必要的气象资料。"
								}, ],
							},
							{
								list: [{
									content1: "从事飞行的民用航空器，应当携带下列文件：(一)民用航空器国籍登记证书；(二)民用航空器适航证书；(三)机组人员相应的执照；(四)民用航空器航行记录簿；(五)装有无线电设备的民用航空器，其无线电台执照；(六)载有旅客的民用航空器，其所载旅客姓名及其出发地点和目的地点的清单；(七)载有货物的民用航空器，其所载货物的舱单和明细的申报单；(八)根据飞行任务应当携带的其他文件。民用航空器未按规定携带前款所列文件的，国务院民用航空主管部门或者其授权的地区民用航空管理机构可以禁止该民用航空器起飞。"
								}, ],
							},
						],

					},
					{
						name: "第八章 公共航空运输企业",
						chapter: [{
								list: [{
									content1: "公共航空运输企业，是指以营利为目的，使用民用航空器运送旅客、行李、邮件或者货物的企业法人。"
								}, ],
							},
							{
								list: [{
									content1: " 设立公共航空运输企业，应当向国务院民用航空主管部门申请领取经营许可证，并依法办理工商登记；未取得经营许可证的，工商行政管理部门不得办理工商登记。"
								}, ],
							},
							{
								list: [{
									content1: "设立公共航空运输企业，应当具备下列条件：(一)有符合国家规定的适应保证飞行安全要求的民用航空器；(二)有必需的依法取得执照的航空人员；(三)有不少于国务院规定的最低限额的注册资本；(四)法律、行政法规规定的其他条件。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业的组织形式、组织机构适用公司法的规定。本法施行前设立的公共航空运输企业，其组织形式、组织机构不完全符合公司法规定的，可以继续沿用原有的规定，适用前款规定的日期由国务院规定。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业应当以保证飞行安全和航班正常，提供良好服务为准则，采取有效措施，提高运输服务质量。公共航空运输企业应当教育和要求本企业职工严格履行职责，以文明礼貌、热情周到的服务态度，认真做好旅客和货物运输的各项服务工作。旅客运输航班延误的，应当在机场内及时通告有关情况。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业申请经营定期航班运输(以下简称航班运输)的航线，暂停、终止经营航线，应当报经国务院民用航空主管部门批准。公共航空运输企业经营航班运输，应当公布班期时刻。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业的营业收费项目，由国务院民用航空主管部门确定。国内航空运输的运价管理办法，由国务院民用航空主管部门会同国务院物价主管部门制定，报国务院批准后执行。国际航空运输运价的制定按照中华人民共和国政府与外国政府签订的协定、协议的规定执行；没有协定、协议的，参照国际航空运输市场价格制定运价，报国务院民用航空主管部门批准后执行。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业从事不定期运输，应当经国务院民用航空主管部门批准，并不得影响航班运输的正常经营。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业应当依照国务院制定的公共航空运输安全保卫规定，制定安全保卫方案，并报国务院民用航空主管部门备案。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业不得运输法律、行政法规规定的禁运物品。公共航空运输企业未经国务院民用航空主管部门批准，不得运输作战军火、作战物资。禁止旅客随身携带法律、行政法规规定的禁运物品乘坐民用航空器。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业运输危险品，应当遵守国家有关规定。禁止以非危险品品名托运危险品。禁止旅客随身携带危险品乘坐民用航空器。除因执行公务并按照国家规定经过批准外，禁止旅客携带枪支、管制刀具乘坐民用航空器。禁止违反国务院民用航空主管部门的规定将危险品作为行李托运。危险品品名由国务院民用航空主管部门规定并公布。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业不得运输拒绝接受安全检查的旅客，不得违反国家规定运输未经安全检查的行李。公共航空运输企业必须按照国务院民用航空主管部门的规定，对承运的货物进行安全检查或者采取其他保证安全的措施。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业从事国际航空运输的民用航空器及其所载人员、行李、货物应当接受边防、海关、检疫等主管部门的检查；但是，检查时应当避免不必要的延误。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业应当依照有关法律、行政法规的规定优先运输邮件。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业应当投保地面第三人责任险。"
								}, ],
							},




						],

					},
					{
						name: "第九章 公共航空运输",
						chapter: [{
								list: [{
									content1: "本章适用于公共航空运输企业使用民用航空器经营的旅客、行李或者货物的运输，包括公共航空运输企业使用民用航空器办理的免费运输。本章不适用于使用民用航空器办理的邮件运输。对多式联运方式的运输，本章规定适用于其中的航空运输部分。"
								}, ],
							},

							{
								list: [{
									content1: "本法所称国内航空运输，是指根据当事人订立的航空运输合同，运输的出发地点、约定的经停地点和目的地点均在中华人民共和国境内的运输。本法所称国际航空运输，是指根据当事人订立的航空运输合同，无论运输有无间断或者有无转运，运输的出发地点、目的地点或者约定的经停地点之一不在中华人民共和国境内的运输。"
								}, ],
							},
							{
								list: [{
									content1: "航空运输合同各方认为几个连续的航空运输承运人办理的运输是一项单一业务活动的，无论其形式是以一个合同订立或者数个合同订立，应当视为一项不可分割的运输。"
								}, ],
							},


							{
								list: [{
									content1: "承运人运送旅客，应当出具客票。旅客乘坐民用航空器，应当交验有效客票。"
								}, ],
							},
							{
								list: [{
									content1: "客票应当包括的内容由国务院民用航空主管部门规定，至少应当包括以下内容：(一)出发地点和目的地点；(二)出发地点和目的地点均在中华人民共和国境内，而在境外有一个或者数个约定的经停地点的，至少注明一个经停地点；(三)旅客航程的最终目的地点、出发地点或者约定的经停地点之一不在中华人民共和国境内，依照所适用的国际航空运输公约的规定，应当在客票上声明此项运输适用该公约的，客票上应当载有该项声明。"
								}, ],
							},
							{
								list: [{
									content1: "客票是航空旅客运输合同订立和运输合同条件的初步证据。旅客未能出示客票、客票不符合规定或者客票遗失，不影响运输合同的存在或者有效。在国内航空运输中，承运人同意旅客不经其出票而乘坐民用航空器的，承运人无权援用本法第一百二十八条有关赔偿责任限制的规定。在国际航空运输中，承运人同意旅客不经其出票而乘坐民用航空器的，或者客票上未依照本法第一百一十条第(三)项的规定声明的，承运人无权援用本法第一百二十九条有关赔偿责任限制的规定。"
								}, ],
							},
							{
								list: [{
									content1: "承运人载运托运行李时，行李票可以包含在客票之内或者与客票相结合。除本法第一百一十条的规定外，行李票还应当包括下列内容：(一)托运行李的件数和重量；(二)需要声明托运行李在目的地点交付时的利益的，注明声明金额。行李票是行李托运和运输合同条件的初步证据。旅客未能出示行李票、行李票不符合规定或者行李票遗失，不影响运输合同的存在或者有效。在国内航空运输中，承运人载运托运行李而不出具行李票的，承运人无权援用本法第一百二十八条有关赔偿责任限制的规定。在国际航空运输中，承运人载运托运行李而不出具行李票的，或者行李票上未依照本法第一百一十条第(三)项的规定声明的，承运人无权援用本法第一百二十九条有关赔偿责任限制的规定。"
								}, ],
							},
							{
								list: [{
									content1: "承运人有权要求托运人填写航空货运单，托运人有权要求承运人接受该航空货运单。托运人未能出示航空货运单、航空货运单不符合规定或者航空货运单遗失，不影响运输合同的存在或者有效。"
								}, ],
							},
							{
								list: [{
									content1: "托运人应当填写航空货运单正本一式三份，连同货物交给承运人。航空货运单第一份注明“交承运人”，由托运人签字、盖章；第二份注明“交收货人”，由托运人和承运人签字、盖章；第三份由承运人在接受货物后签字、盖章，交给托运人。承运人根据托运人的请求填写航空货运单的，在没有相反证据的情况下，应当视为代托运人填写。"
								}, ],
							},
							{
								list: [{
									content1: "航空货运单应当包括的内容由国务院民用航空主管部门规定，至少应当包括以下内容：(一)出发地点和目的地点；(二)出发地点和目的地点均在中华人民共和国境内，而在境外有一个或者数个约定的经停地点的，至少注明一个经停地点；(三)货物运输的最终目的地点、出发地点或者约定的经停地点之一不在中华人民共和国境内，依照所适用的国际航空运输公约的规定，应当在货运单上声明此项运输适用该公约的，货运单上应当载有该项声明。"
								}, ],
							},
							{
								list: [{
									content1: "在国内航空运输中，承运人同意未经填具航空货运单而载运货物的，承运人无权援用本法第一百二十八条有关赔偿责任限制的规定。在国际航空运输中，承运人同意未经填具航空货运单而载运货物的，或者航空货运单上未依照本法第一百一十五条第(三)项的规定声明的，承运人无权援用本法第一百二十九条有关赔偿责任限制的规定。"
								}, ],
							},
							{
								list: [{
									content1: "托运人应当对航空货运单上所填关于货物的说明和声明的正确性负责。因航空货运单上所填的说明和声明不符合规定、不正确或者不完全，给承运人或者承运人对之负责的其他人造成损失的，托运人应当承担赔偿责任。"
								}, ],
							},
							{
								list: [{
									content1: "航空货运单是航空货物运输合同订立和运输条件以及承运人接受货物的初步证据。航空货运单上关于货物的重量、尺寸、包装和包装件数的说明具有初步证据的效力。除经过承运人和托运人当面查对并在航空货运单上注明经过查对或者书写关于货物的外表情况的说明外，航空货运单上关于货物的数量、体积和情况的说明不能构成不利于承运人的证据。"
								}, ],
							},
							{
								list: [{
									content1: "托运人在履行航空货物运输合同规定的义务的条件下，有权在出发地机场或者目的地机场将货物提回，或者在途中经停时中止运输，或者在目的地点或者途中要求将货物交给非航空货运单上指定的收货人，或者要求将货物运回出发地机场；但是，托运人不得因行使此种权利而使承运人或者其他托运人遭受损失，并应当偿付由此产生的费用。托运人的指示不能执行的，承运人应当立即通知托运人。承运人按照托运人的指示处理货物，没有要求托运人出示其所收执的航空货运单，给该航空货运单的合法持有人造成损失的，承运人应当承担责任，但是不妨碍承运人向托运人追偿。收货人的权利依照本法第一百二十条规定开始时，托运人的权利即告终止；但是，收货人拒绝接受航空货运单或者货物，或者承运人无法同收货人联系的，托运人恢复其对货物的处置权。"
								}, ],
							},
							{
								list: [{
									content1: "除本法第一百一十九条所列情形外，收货人于货物到达目的地点，并在缴付应付款项和履行航空货运单上所列运输条件后，有权要求承运人移交航空货运单并交付货物。除另有约定外，承运人应当在货物到达后立即通知收货人。承运人承认货物已经遗失，或者货物在应当到达之日起七日后仍未到达的，收货人有权向承运人行使航空货物运输合同所赋予的权利。"
								}, ],
							},
							{
								list: [{
									content1: "托运人和收货人在履行航空货物运输合同规定的义务的条件下，无论为本人或者他人的利益，可以以本人的名义分别行使本法第一百一十九条和第一百二十条所赋予的权利。"
								}, ],
							},
							{
								list: [{
									content1: "本法第一百一十九条、第一百二十条和第一百二十一条的规定，不影响托运人同收货人之间的相互关系，也不影响从托运人或者收货人获得权利的第三人之间的关系。任何与本法第一百一十九条、第一百二十条和第一百二十一条规定不同的合同条款，应当在航空货运单上载明。"
								}, ],
							},
							{
								list: [{
									content1: "托运人应当提供必需的资料和文件，以便在货物交付收货人前完成法律、行政法规规定的有关手续；因没有此种资料、文件，或者此种资料、文件不充足或者不符合规定造成的损失，除由于承运人或者其受雇人、代理人的过错造成的外，托运人应当对承运人承担责任。除法律、行政法规另有规定外，承运人没有对前款规定的资料或者文件进行检查的义务。"
								}, ],
							},
							{
								list: [{
									content1: " 因发生在民用航空器上或者在旅客上、下民用航空器过程中的事件，造成旅客人身伤亡的，承运人应当承担责任；但是，旅客的人身伤亡完全是由于旅客本人的健康状况造成的，承运人不承担责任。"
								}, ],
							},
							{
								list: [{
									content1: " 因发生在民用航空器上或者在旅客上、下民用航空器过程中的事件，造成旅客随身携带物品毁灭、遗失或者损坏的，承运人应当承担责任。因发生在航空运输期间的事件，造成旅客的托运行李毁灭、遗失或者损坏的，承运人应当承担责任。旅客随身携带物品或者托运行李的毁灭、遗失或者损坏完全是由于行李本身的自然属性、质量或者缺陷造成的，承运人不承担责任。本章所称行李，包括托运行李和旅客随身携带的物品。因发生在航空运输期间的事件，造成货物毁灭、遗失或者损坏的，承运人应当承担责任；但是，承运人证明货物的毁灭、遗失或者损坏完全是由于下列原因之一造成的，不承担责任：(一)货物本身的自然属性、质量或者缺陷；(二)承运人或者其受雇人、代理人以外的人包装货物的，货物包装不良；(三)战争或者武装冲突；(四)政府有关部门实施的与货物入境、出境或者过境有关的行为。本条所称航空运输期间，是指在机场内、民用航空器上或者机场外降落的任何地点，托运行李、货物处于承运人掌管之下的全部期间。航空运输期间，不包括机场外的任何陆路运输、海上运输、内河运输过程；但是，此种陆路运输、海上运输、内河运输是为了履行航空运输合同而装载、交付或者转运，在没有相反证据的情况下，所发生的损失视为在航空运输期间发生的损失。"
								}, ],
							},
							{
								list: [{
									content1: "旅客、行李或者货物在航空运输中因延误造成的损失，承运人应当承担责任；但是，承运人证明本人或者其受雇人、代理人为了避免损失的发生，已经采取一切必要措施或者不可能采取此种措施的，不承担责任。"
								}, ],
							},
							{
								list: [{
									content1: "在旅客、行李运输中，经承运人证明，损失是由索赔人的过错造成或者促成的，应当根据造成或者促成此种损失的过错的程度，相应免除或者减轻承运人的责任。旅客以外的其他人就旅客死亡或者受伤提出赔偿请求时，经承运人证明，死亡或者受伤是旅客本人的过错造成或者促成的，同样应当根据造成或者促成此种损失的过错的程度，相应免除或者减轻承运人的责任。在货物运输中，经承运人证明，损失是由索赔人或者代行权利人的过错造成或者促成的，应当根据造成或者促成此种损失的过错的程度，相应免除或者减轻承运人的责任。"
								}, ],
							},
							{
								list: [{
									content1: "国内航空运输承运人的赔偿责任限额由国务院民用航空主管部门制定，报国务院批难后公布执行。旅客或者托运人在交运托运行李或者货物时，特别声明在目的地点交付时的利益，并在必要时支付附加费的，除承运人证明旅客或者托运人声明的金额高于托运行李或者货物在目的地点交付时的实际利益外，承运人应当在声明金额范围内承担责任；本法第一百二十九条的其他规定，除赔偿责任限额外，适用于国内航空运输。"
								}, ],
							},
							{
								list: [{
									content1: "国际航空运输承运人的赔偿责任限额按照下列规定执行：(一)对每名旅客的赔偿责任限额为 16600 计算单位；但是，旅客可以同承运人书面约定高于本项规定的赔偿责任限额。(二)对托运行李或者货物的赔偿责任限额，每公斤为 17 计算单位。旅客或者托运人在交运托运行李或者货物时，特别声明在目的地点交付时的利益，并在必要时支付附加费的，除承运人证明旅客或者托运人声明的金额高于托运行李或者货物在目的地点交付时的实际利益外，承运人应当在声明金额范围内承担责任。托运行李或者货物的一部分或者托运行李、货物中的任何物件毁灭、遗失、损坏或者延误的，用以确定承运人赔偿责任限额的重量，仅为该一包件或者数包件的总重量；但是，因托运行李或者货物的一部分或者托运行李、货物中的任何物件的毁灭、遗失、损坏或者延误，影响同一份行李票或者同一份航空货运单所列其他包件的价值的，确定承运人的赔偿责任限额时，此种包件的总重量也应当考虑在内。(三)对每名旅客随身携带的物品的赔偿责任限额为 332 计算单位。"
								}, ],
							},
							{
								list: [{
									content1: "任何旨在免除本法规定的承运人责任或者降低本法规定的赔偿责任限额的条款，均属无效；但是，此种条款的无效，不影响整个航空运输合同的效力。"
								}, ],
							},
							{
								list: [{
									content1: "有关航空运输中发生的损失的诉讼，不论其根据如何，只能依照本法规定的条件和赔偿责任限额提出，但是不妨碍谁有权提起诉讼以及他们各自的权利。"
								}, ],
							},
							{
								list: [{
									content1: "经证明，航空运输中的损失是由于承运人或者其受雇人、代理人的故意或者明知可能造成损失而轻率地作为或者不作为造成的，承运人无权援用本法第一百二十八条、第一百二十九条有关赔偿责任限制的规定；证明承运人的受雇人、代理人有此种作为或者不作为的，还应当证明该受雇人、代理人是在受雇、代理范围内行事。"
								}, ],
							},
							{
								list: [{
									content1: "就航空运输中的损失向承运人的受雇人、代理人提起诉讼时，该受雇人、代理人证明他是在受雇、代理范围内行事的，有权援用本法第一百二十八条、第一百二十九条有关赔偿责任限制的规定。在前款规定情形下，承运人及其受雇人、代理人的赔偿总额不得超过法定的赔偿责任限额。经证明，航空运输中的损失是由于承运人的受雇人、代理人的故意或者明知可能造成损失而轻率地作为或者不作为造成的，不适用本条第一款和第二款的规定。第一百三十四条 旅客或者收货人收受托运行李或者货物而未提出异议，为托运行李或者货物已经完好交付并与运输凭证相符的初步证据。托运行李或者货物发生损失的，旅客或者收货人应当在发现损失后向承运人提出异议。托运行李发生损失的，至迟应当自收到托运行李之日起 7 日内提出；货物发生损失的，至迟应当自收到货物之日起 14 日内提出。托运行李或者货物发生延误的，至迟应当自托运行李或者货物交付旅客或者收货人处置之日起 21 日内提出。任何异议均应当在前款规定的期间内写在运输凭证上或者另以书面提出。除承运人有欺诈行为外，旅客或者收货人未在本条第二款规定的期间内提出异议的，不能向承运人提出索赔诉讼。"
								}, ],
							},
							{
								list: [{
									content1: "航空运输的诉讼时效期间为二年，自民用航空器到达目的地点、应当到达目的地点或者运输终止之日起计算。"
								}, ],
							},
							{
								list: [{
									content1: "由几个航空承运人办理的连续运输，接受旅客、行李或者货物的每一个承运人应当受本法规定的约束，并就其根据合同办理的运输区段作为运输合同的订约一方。对前款规定的连续运输，除合同明文约定第一承运人应当对全程运输承担责任外，旅客或者其继承人只能对发生事故或者延误的运输区段的承运人提起诉讼。托运行李或者货物的毁灭、遗失、损坏或者延误，旅客或者托运人有权对第一承运人提起诉讼，旅客或者收货人有权对最后承运人提起诉讼，旅客、托运人和收货人均可以对发生毁灭、遗失、损坏或者延误的运输区段的承运人提起诉讼。上述承运人应当对旅客、托运人或者收货人承担连带责任。"
								}, ],
							},
							{
								list: [{
									content1: "本节所称缔约承运人，是指以本人名义与旅客或者托运人，或者与旅客或者托运人的代理人，订立本章调整的航空运输合同的人。本节所称实际承运人，是指根据缔约承运人的授权，履行前款全部或者部分运输的人，不是指本章规定的连续承运人；在没有相反证明时，此种授权被认为是存在的。"
								}, ],
							},
							{
								list: [{
									content1: "除本节另有规定外，缔约承运人和实际承运人都应当受本章规定的约束。缔约承运人应当对合同约定的全部运输负责。实际承运人应当对其履行的运输负责。"
								}, ],
							},
							{
								list: [{
									content1: "实际承运人的作为和不作为，实际承运人的受雇人、代理人在受雇、代理范围内的作为和不作为，关系到实际承运人履行的运输的，应当视为缔约承运人的作为和不作为。缔约承运人的作为和不作为，缔约承运人的受雇人、代理人在受雇、代理范围内的作为和不作为，关系到实际承运人履行的运输的，应当视为实际承运人的作为和不作为；但是，实际承运人承担的责任不因此种作为或者不作为而超过法定的赔偿责任限额。任何有关缔约承运人承担本章未规定的义务或者放弃本章赋予的权利的特别协议，或者任何有关依照本法第一百二十八条、第一百二十九条规定所作的在目的地点交付时利益的特别声明，除经实际承运人同意外，均不得影响实际承运人。第一百四十条 依照本章规定提出的索赔或者发出的指示，无论是向缔约承运人还是向实际承运人提出或者发出的，具有同等效力；但是，本法第一百一十九条规定的指示，只在向缔约承运人发出时，方有效。"
								}, ],
							},
							{
								list: [{
									content1: "实际承运人的受雇人、代理人或者缔约承运人的受雇人、代理人， 证明他是在受雇、 代理范围内行事的， 就实际承运人履行的运输而言， 有权援用本法第一百二十八条、 第一百二十九条有关赔偿责任限制的规定， 但是依照本法规定不得援用赔偿责任限制规定的除外。 "
								}, ],
							},
							{
								list: [{
									content1: "对于实际承运人履行的运输，实际承运人、缔约承运人以及他们的在受雇、代理范围内行事的受雇人、代理人的赔偿总额不得超过依照本法得以从缔约承运人或者实际承运人获得赔偿的最高数额；但是，其中任何人都不承担超过对他适用的赔偿责任限额。"
								}, ],
							},
							{
								list: [{
									content1: "对实际承运人履行的运输提起的诉讼，可以分别对实际承运人或者缔约承运人提起，也可以同时对实际承运人和缔约承运人提起；被提起诉讼的承运人有权要求另一承运人参加应诉。"
								}, ],
							},
							{
								list: [{
									content1: "除本法第一百四十三条规定外，本节规定不影响实际承运人和缔约承运人之间的权利、义务。"
								}, ],
							},




						],

					},
					{
						name: "第十章 通用航空",
						chapter: [{
								list: [{
									content1: "通用航空，是指使用民用航空器从事公共航空运输以外的民用航空活动，包括从事工业、农业、林业、渔业和建筑业的作业飞行以及医疗卫生、抢险救灾、气象探测、海洋监测、科学实验、教育训练、文化体育等方面的飞行活动。 "
								}, ],
							},
							{
								list: [{
									content1: "从事通用航空活动，应当具备下列条件：(一) 有与所从事的通用航空活动相适应， 符合保证飞行安全要求的民用航空器；(二) 有必需的依法取得执照的航空人员；(三) 符合法律、 行政法规规定的其他条件。从事经营性通用航空， 限于企业法人。 "
								}, ],
							},
							{
								list: [{
									content1: "从事非经营性通用航空的，应当向国务院民用航空主管部门办理登记。从事经营性通用航空的，应当向国务院民用航空主管部门申请领取通用航空经营许可证，并依法办理工商登记；未取得经营许可证的，工商行政管理部门不得办理工商登记。"
								}, ],
							},
							{
								list: [{
									content1: "通用航空企业从事经营性通用航空活动，应当与用户订立书面合同，但是紧急情况下的救护或者救灾飞行除外。"
								}, ],
							},
							{
								list: [{
									content1: "组织实施作业飞行时，应当采取有效措施，保证飞行安全，保护环境和生态平衡，防止对环境、居民、作物或者牲畜等造成损害。"
								}, ],
							},
							{
								list: [{
									content1: "从事通用航空活动的，应当投保地面第三人责任险。"
								}, ],
							},
						],

					},
					{
						name: "第十一章 搜寻援救和事故调查",
						chapter: [{
								list: [{
									content1: "民用航空器遇到紧急情况时，应当发送信号，并向空中交通管制单位报告，提出援救请求；空中交通管制单位应当立即通知搜寻援救协调中心。民用航空器在海上遇到紧急情况时，还应当向船舶和国家海上搜寻援救组织发送信号。"
								}, ],
							},

							{
								list: [{
									content1: "发现民用航空器遇到紧急情况或者收听到民用航空器遇到紧急情况的信号的单位或者个人，应当立即通知有关的搜寻援救协调中心、海上搜寻援救组织或者当地人民政府。"
								}, ],
							},
							{
								list: [{
									content1: "收到通知的搜寻援救协调中心、地方人民政府和海上搜寻援救组织，应当立即组织搜寻援救。收到通知的搜寻援救协调中心，应当设法将已经采取的搜寻援救措施通知遇到紧急情况的民用航空器。搜寻援救民用航空器的具体办法，由国务院规定。"
								}, ],
							},
							{
								list: [{
									content1: "执行搜寻援救任务的单位或者个人，应当尽力抢救民用航空器所载人员，按照规定对民用航空器采取抢救措施并保护现场，保存证据。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器事故的当事人以及有关人员在接受调查时，应当如实提供现场情况和与事故有关的情节。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器事故调查的组织和程序，由国务院规定。"
								}, ],
							},
						],

					},
					{
						name: "第十二章 对地面第三人损害的赔偿责任",
						chapter: [

							{
								list: [{
									content1: " 因飞行中的民用航空器或者从飞行中的民用航空器上落下的人或者物，造成地面(包括水面，下同)上的人身伤亡或者财产损害的，受害人有权获得赔偿；但是，所受损害并非造成损害的事故的直接后果，或者所受损害仅是民用航空器依照国家有关的空中交通规则在空中通过造成的，受害人无权要求赔偿。前款所称飞行中，是指自民用航空器为实际起飞而使用动力时起至着陆冲程终了时止；就轻于空气的民用航空器而言，飞行中是指自其离开地面时起至其重新着地时止。"
								}, ],
							},
							{
								list: [{
									content1: "本法第一百五十七条规定的赔偿责任，由民用航空器的经营人承担。前款所称经营人，是指损害发生时使用民用航空器的人。民用航空器的使用权已经直接或者间接地授予他人，本人保留对该民用航空器的航行控制权的，本人仍被视为经营人。经营人的受雇人、代理人在受雇、代理过程中使用民用航空器，无论是否在其受雇、代理范围内行事，均视为经营人使用民用航空器。民用航空器登记的所有人应当被视为经营人，并承担经营人的责任；除非在判定其责任的诉讼中，所有人证明经营人是他人，并在法律程序许可的范围内采取适当措施使该人成为诉讼当事人之一。"
								}, ],
							},
							{
								list: [{
									content1: "未经对民用航空器有航行控制权的人同意而使用民用航空器，对地面第三人造成损害的，有航行控制权的人除证明本人已经适当注意防止此种使用外，应当与该非法使用人承担连带责任。"
								}, ],
							},
							{
								list: [{
									content1: "损害是武装冲突或者骚乱的直接后果，依照本章规定应当承担责任的人不承担责任。依照本章规定应当承担责任的人对民用航空器的使用权业经国家机关依法剥夺的，不承担责任。"
								}, ],
							},
							{
								list: [{
									content1: "依照本章规定应当承担责任的人证明损害是完全由于受害人或者其受雇人、代理人的过错造成的，免除其赔偿责任；应当承担责任的人证明损害是部分由于受害人或者其受雇人、代理人的过错造成的，相应减轻其赔偿责任。但是，损害是由于受害人的受雇人、代理人的过错造成的，受害人证明其受雇人、代理人的行为超出其所授权的范围内，不免除或者不减轻应当承担责任的人的赔偿责任。一人对另一人的死亡或者伤害提起诉讼，请求赔偿时，损害是该另一人或者其受雇人、代理人的过错造成的，适用前款规定。"
								}, ],
							},
							{
								list: [{
									content1: "两个以上的民用航空器在飞行中相撞或者相扰，造成本法第一百五十七条规定的应当赔偿的损害，或者两个以上的民用航空器共同造成此种损害的，各有关民用航空器均应当被认为已经造成此种损害，各有关民用航空器的经营人均应当承担责任。"
								}, ],
							},
							{
								list: [{
									content1: "本法第一百五十八条第四款和第一百五十九条规定的人，享有依照本章规定经营人所能援用的抗辩权。"
								}, ],
							},
							{
								list: [{
									content1: "除本章有明确规定外，经营人、所有人和本法第一百五十九条规定的应当承担责任的人，以及他们的受雇人、代理人，对于飞行中的民用航空器或者从飞行中的民用航空器上落下的人或者物造成的地面上的损害不承担责任，但是故意造成此种损害的人除外。"
								}, ],
							},
							{
								list: [{
									content1: "本章不妨碍依照本章规定应当对损害承担责任的人向他人追偿的权利。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器的经营人应当投保地面第三人责任险或者取得相应的责任担保。"
								}, ],
							},
							{
								list: [{
									content1: "保险人和担保人除享有与经营人相同的抗辩权，以及对伪造证件进行抗辩的权利外，对依照本章规定提出的赔偿请求只能进行下列抗辩：(一)损害发生在保险或者担保终止有效后；然而保险或者担保在飞行中期满的，该项保险或者担保在飞行计划中所载下一次降落前继续有效，但是不得超过二十四小时；(二)损害发生在保险或者担保所指定的地区范围外，除非飞行超出该范围是由于不可抗力、援助他人所必需，或者驾驶、航行或者领航上的差错造成的。前款关于保险或者担保继续有效的规定，只在对受害人有利时适用。"
								}, ],
							},
							{
								list: [{
									content1: "仅在下列情形下，受害人可以直接对保险人或者担保人提起诉讼，但是不妨碍受害人根据有关保险合同或者担保合同的法律规定提起直接诉讼的权利：(一)根据本法第一百六十七条第(一)项、第(二)项规定，保险或者担保继续有效的；(二)经营人破产的。除本法第一百六十七条第一款规定的抗辩权，保险人或者担保人对受害人依照本章规定提起的直接诉讼不得以保险或者担保的无效或者追溯力终止为由进行抗辩。"
								}, ],
							},
							{
								list: [{
									content1: "依照本法第一百六十六条规定提供的保险或者担保，应当被专门指定优先支付本章规定的赔偿。"
								}, ],
							},
							{
								list: [{
									content1: "保险人应当支付给经营人的款项，在本章规定的第三人的赔偿请求未满足前，不受经营人的债权人的扣留和处理。"
								}, ],
							},
							{
								list: [{
									content1: "地面第三人损害赔偿的诉讼时效期间为二年，自损害发生之日起计算；但是，在任何情况下，时效期间不得超过自损害发生之日起三年。第一百七十二条 本章规定不适用于下列损害：(一)对飞行中的民用航空器或者对该航空器上的人或者物造成的损害；(二)为受害人同经营人或者同发生损害时对民用航空器有使用权的人订立的合同所约束，或者为适用两方之间的劳动合同的法律有关职工赔偿的规定所约束的损害；(三)核损害。"
								}, ],
							},

						],

					},
					{
						name: "第十三章 对外国民用航空器的特别规定",
						chapter: [

							{
								list: [{
									content1: "外国人经营的外国民用航空器，在中华人民共和国境内从事民用航空活动，适用本章规定；本章没有规定的，适用本"
								}, ],
							},

							{
								list: [{
									content1: "外国民用航空器根据其国籍登记国政府与中华人民共和国政府签订的协定、协议的规定，或者经中华人民共和国国务院民用航空主管部门批准或者接受，方可飞入、飞出中华人民共和国领空和在中华人民共和国境内飞行、降落。对不符合前款规定，擅自飞入、飞出中华人民共和国领空的外国民用航空器，中华人民共和国有关机关有权采取必要措施，令其在指定的机场降落；对虽然符合前款规定，但是有合理的根据认为需要对其进行检查的，有关机关有权令其在指定的机场降落。"
								}, ],
							},
							{
								list: [{
									content1: "外国民用航空器飞入中华人民共和国领空，其经营人应当提供有关证明书，证明其已经投保地面第三人责任险或者已经取得相应的责任担保；其经营人未提供有关证明书的，中华人民共和国国务院民用航空主管部门有权拒绝其飞入中华人民共和国领空。"
								}, ],
							},

							{
								list: [{
									content1: "外国民用航空器的经营人经其本国政府指定，并取得中华人民共和国国务院民用航空主管部门颁发的经营许可证，方可经营中华人民共和国政府与该外国政府签订的协定、协议规定的国际航班运输；外国民用航空器的经营人经其本国政府批准，并获得中华人民共和国国务院民用航空主管部门批准，方可经营中华人民共和国境内一地和境外一地之间的不定期航空运输。前款规定的外国民用航空器经营人，应当依照中华人民共和国法律、行政法规的规定，制定相应的安全保卫方案，报中华人民共和国国务院民用航空主管部门备案。"
								}, ],
							},
							{
								list: [{
									content1: "外国民用航空器的经营人，不得经营中华人民共和国境内两点之间的航空运输。"
								}, ],
							},
							{
								list: [{
									content1: "外国民用航空器，应当按照中华人民共和国国务院民用航空主管部门批准的班期时刻或者飞行计划飞行；变更班期时刻或者飞行计划的，其经营人应当获得中华人民共和国国务院民用航空主管部门的批准；因故变更或者取消飞行的，其经营人应当及时报告中华人民共和国国务院民用航空主管部门。"
								}, ],
							}, {
								list: [{
									content1: "外国民用航空器应当在中华人民共和国国务院民用航空主管部门指定的设关机场起飞或者降落。"
								}, ],
							},
							{
								list: [{
									content1: "中华人民共和国国务院民用航空主管部门和其他主管机关，有权在外国民用航空器降落或者飞出时查验本法第九十条规定的文件。外国民用航空器及其所载人员、行李、货物，应当接受中华人民共和国有关主管机关依法实施的入境出境、海关、检疫等检查。实施前两款规定的查验、检查，应当避免不必要的延误。"
								}, ],
							},
							{
								list: [{
									content1: "外国民用航空器国籍登记国发给或者核准的民用航空器适航证书、机组人员合格证书和执照，中华人民共和国政府承认其有效；但是，发给或者核准此项证书或者执照的要求，应当等于或者高于国际民用航空组织制定的最低标准。"
								}, ],
							},
							{
								list: [{
									content1: "外国民用航空器在中华人民共和国搜寻援救区内遇险，其所有人或者国籍登记国参加搜寻援救工作，应当经中华人民共和国国务院民用航空主管部门批准或者按照两国政府协议进行。"
								}, ],
							},
							{
								list: [{
									content1: "外国民用航空器在中华人民共和国境内发生事故，其国籍登记国和其他有关国家可以指派观察员参加事故调查。事故调查报告和调查结果，由中华人民共和国国务院民用航空主管部门告知该外国民用航空器的国籍登记国和其他有关国家。"
								}, ],
							},


						],

					},
					{
						name: "第十四章 涉外关系的法律适用",
						chapter: [{
								list: [{
									content1: "中华人民共和国缔结或者参加的国际条约同本法有不同规定的，适用国际条约的规定；但是，中华人民共和国声明保留的条款除外。中华人民共和国法律和中华人民共和国缔结或者参加的国际条约没有规定的，可以适用国际惯例。"
								}, ],
							},


							{
								list: [{
									content1: "民用航空器所有权的取得、转让和消灭，适用民用航空器国籍登记国法律。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器抵押权适用民用航空器国籍登记国法律。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器优先权适用受理案件的法院所在地法律。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空运输合同当事人可以选择合同适用的法律，但是法律另有规定的除外；合同当事人没有选择的，适用与合同有最密切联系的国家的法律。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器对地面第三人的损害赔偿，适用侵权行为地法律。民用航空器在公海上空对水面第三人的损害赔偿，适用受理案件的法院所在地法律。"
								}, ],
							},
							{
								list: [{
									content1: "依照本章规定适用外国法律或者国际惯例，不得违背中华人民共和国的社会公共利益。"
								}, ],
							},
						],

					},
					{
						name: "第十五章 法律责任",
						chapter: [



							{
								list: [{
									content1: "以暴力、胁迫或者其他方法劫持航空器的，依照关于惩治劫持航空器犯罪分子的决定追究刑事责任。"
								}, ],
							},
							{
								list: [{
									content1: "对飞行中的民用航空器上的人员使用暴力，危及飞行安全，尚未造成严重后果的，依照刑法第一百零五条的规定追究刑事责任；造成严重后果的，依照刑法第一百零六条的规定追究刑事责任。"
								}, ],
							},
							{
								list: [{
									content1: "违反本法规定，隐匿携带炸药、雷管或者其他危险品乘坐民用航空器，或者以非危险品品名托运危险品，尚未造成严重后果的，比照刑法第一百六十三条的规定追究刑事责任；造成严重后果的，依照刑法第一百一十条的规定追究刑事责任。企业事业单位犯前款罪的，判处罚金，并对直接负责的主管人员和其他直接责任人员依照前款规定追究刑事责任。隐匿携带枪支子弹、管制刀具乘坐民用航空器的，比照刑法第一百六十三条的规定追究刑事责任。"
								}, ],
							},

							{
								list: [{
									content1: "公共航空运输企业违反本法第一百零一条的规定运输危险品的，由国务院民用航空主管部门没收违法所得，可以并处违法所得一倍以下的罚款。公共航空运输企业有前款行为，导致发生重大事故的，没收违法所得，判处罚金；并对直接负责的主管人员和其他直接责任人员依照刑法第一百一十五条的规定追究刑事责任。"
								}, ],
							},
							{
								list: [{
									content1: "故意在使用中的民用航空器上放置危险品或者唆使他人放置危险品，足以毁坏该民用航空器，危及飞行安全，尚未造成严重后果的，依照刑法第一百零七条的规定追究刑事责任；造成严重后果的，依照刑法第一百一十条的规定追究刑事责任。"
								}, ],
							},
							{
								list: [{
									content1: "故意传递虚假情报，扰乱正常飞行秩序，使公私财产遭受重大损失的，依照刑法第一百五十八条的规定追究刑事责任。"
								}, ],
							},
							{
								list: [{
									content1: "盗窃或者故意损毁、移动使用中的航行设施，危及飞行安全，足以使民用航空器发生坠落、毁坏危险，尚未造成严重后果的，依照刑法第一百零八条的规定追究刑事责任；造成严重后果的，依照刑法第一百一十条的规定追究刑事责任。"
								}, ],
							},
							{
								list: [{
									content1: "聚众扰乱民用机场秩序的，依照刑法第一百五十九条的规定追究刑事责任。"
								}, ],
							},
							{
								list: [{
									content1: " 航空人员玩忽职守，或者违反规章制度，导致发生重大飞行事故，造成严重后果的，分别依照、比照刑法第一百八十七条或者第一百一十四条的规定追究刑事责任。"
								}, ],
							},
							{
								list: [{
									content1: "违反本法规定，尚不够刑事处罚，应当给予治安管理处罚的，依照治安管理处罚条例的规定处罚。"
								}, ],
							},
							{
								list: [{
									content1: "违反本法第三十七条的规定，民用航空器无适航证书而飞行，或者租用的外国民用航空器未经国务院民用航空主管部门对其原国籍登记国发给的适航证书审查认可或者另发适航证书而飞行的，由国务院民用航空主管部门责令停止飞行，没收违法所得，可以并处违法所得 1 倍以上 5 倍以下的罚款；没有违法所得的，处以 10 万元以上 100 万元以下的罚款。适航证书失效或者超过适航证书规定范围飞行的，依照前款规定处罚。"
								}, ],
							},
							{
								list: [{
									content1: "违反本法第三十四条、第三十六条第二款的规定，将未取得型号合格证书、型号认可证书的民用航空器及其发动机、螺旋桨或者民用航空器上的设备投入生产的，由国务院民用航空主管部门责令停止生产，没收违法所得，可以并处违法所得一倍以下的罚款；没有违法所得的，处以五万元以上五十万元以下的罚款。"
								}, ],
							},
							{
								list: [{
									content1: "违反本法第三十五条的规定，未取得生产许可证书、维修许可证书而从事生产、维修活动的，违反本法第九十二条、第一百四十七条第二款的规定，未取得公共航空运输经营许可证或者通用航空经营许可证而从事公共航空运输或者从事经营性通用航空的，国务院民用航空主管部门可以责令停止生产、维修或者经营活动。"
								}, ],
							},
							{
								list: [{
									content1: "已取得本法第三十五条规定的生产许可证书、维修许可证书的企业，因生产、维修的质量问题造成严重事故的，国务院民用航空主管部门可以吊销其生产许可证书或者维修许可证书。"
								}, ],
							},
							{
								list: [{
									content1: "违反本法第四十条的规定，未取得航空人员执照、体格检查合格证书而从事相应的民用航空活动的，由国务院民用航空主管部门责令停止民用航空活动，在国务院民用航空主管部门规定的限期内不得申领有关执照和证书，对其所在单位处以二十万元以下的罚款。"
								}, ],
							},
							{
								list: [{
									content1: "有下列违法情形之一的，由国务院民用航空主管部门对民用航空器的机长给予警告或者吊扣执照一个月至六个月的处罚，情节较重的，可以给予吊销执照的处罚：(一)机长违反本法第四十五条第一款的规定，未对民用航空器实施检查而起飞的；(二)民用航空器违反本法第七十五条的规定，未按照空中交通管制单位指定的航路和飞行高度飞行，或者违反本法第七十九条的规定飞越城市上空的。第二百零七条 违反本法第七十四条的规定，民用航空器未经空中交通管制单位许可进行飞行活动的，由国务院民用航空主管部门责令停止飞行，对该民用航空器所有人或者承租人处以 1 万元以上 10 万元以下的罚款 ；对该民用航空器的机长给予警告或者吊扣执照 1 个月至 6 个月的处罚，情节较重的，可以给予吊销执照的处罚。"
								}, ],
							},
							{
								list: [{
									content1: "民用航空器的机长或者机组其他人员有下列行为之一的，由国务院民用航空主管部门给予警告或者吊扣执照一个月至六个月的处罚；有第(二)项或者第(三)项所列行为的，可以给予吊销执照的处罚：(一)在执行飞行任务时，不按照本法第四十一条的规定携带执照和体格检查合格证书的；(二)民用航空器遇险时，违反本法第四十八条的规定离开民用航空器的；(三)违反本法第七十七条第二款的规定执行飞行任务的。第二百零九条 违反本法第八十条的规定，民用航空器在飞行中投掷物品的，由国务院民用航空主管部门给予警告，可以对直接责任人员处以 1000 元以上 2 万元以下的罚款。"
								}, ],
							},
							{
								list: [{
									content1: "违反本法第六十二条的规定，未取得机场使用许可证开放使用民用机场的，由国务院民用航空主管部门责令停止开放使用；没收违法所得，可以并处违法所得一倍以下的罚款。"
								}, ],
							},
							{
								list: [{
									content1: "公共航空运输企业、通用航空企业违反本法规定，情节较重的，除依照本法规定处罚外，国务院民用航空主管部门可以吊销其经营许可证。对被吊销经营许可证的，工商行政管理部门应吊销其营业执照"
								}, ],
							},
							{
								list: [{
									content1: "国务院民用航空主管部门和地区民用航空管理机构的工作人员，玩忽职守、滥用职权、徇私舞弊，构成犯罪的，依法追究刑事责任；尚不构成犯罪的，依法给予行政处分。"
								}, ],
							},

						],

					},
					{
						name: "第十六章 附 则",
						chapter: [{
								list: [{
									content1: "本法所称计算单位，是指国际货币基金组织规定的特别提款权；其人民币数额为法院判决之日、仲裁机构裁决之日或者当事人协议之日，按照国家外汇主管机关规定的国际货币基金组织的特别提款权对人民币的换算办法计算得出的人民币数额。"
								}, ],
							},
							{
								list: [{
									content1: "本法自 1996 年 3 月 1 日起施行。"
								}, ],
							},

						],

					},

				],
				aboutList2: [{
						name: "第一章 总 则",
						chapter: [{
								list: [{
										content1: "为加强危险品航空运输管理，促进危险品航空运输发展，保证航空运输安全，根据《中华人民共和国民用航空法》和有关法律、行政法规，制定本规定。"
									},

								],
							},
							{
								list: [{
										content1: "本规定适用于国内公共航空运输经营人（以下简称国内经营人）、在外国和中国地点间进行定期航线经营或者不定期飞行的外国公共航空运输经营人（以下简称外国经营人）以及与危险品航空运输活动有关的任何单位和个人。"
									},
									{
										content1: "中国民用航空局(以下简称民航局)依据职责对全国危险品航空运输活动实施监督管理，中国民用航空地区管理局(以下简称民航地区管理局)依据职责对辖区内的危险品航空运输活动实施监督管理。 "
									},
								],
							},

							{
								list: [{
										content1: "本规定中下列用语，除具体条款中另有规定外，含义如下：（一）“ 危险品” 是指列在《 技术细则》 危险品清单中或者根据该细则归类的能对健康、 安全、 财产或者环境构成危险的物品或者物质。（ 二）《 技术细则》 是指根据国际民航组织理事会制定的程序而定期批准和公布的《 危险物品安全航空运输技术细则》（ Doc9284 号文件）。（ 三）“ 经营人” 是指以营利为目的使用民用航空器从事旅客、行李、 货物、 邮件运输的公共航空运输企业， 包括国内经营人和外国经营人。（ 四）“ 托运人” 是指为货物运输与承运人订立合同， 并在航空货运单或者货物记录上署名的人。（ 五）“ 货运销售代理人” 是指经经营人授权， 代表经营人从事货物航空运输销售活动的企业。（ 六）“ 地面服务代理人” 是指经经营人授权， 代表经营人从事各项航空运输地面服务的企业。（ 七）“ 托运物” 是经营人一次在一个地址， 从一个托运人处接收的， 按一批和一个目的地地址的一个收货人出具收据的一个或者多个危险品包装件。（ 八）“ 机长” 是指由经营人指定的在飞行中负有指挥职能并负责飞行安全操作的驾驶员。（ 九）“ 危险品事故” 是指与危险品航空运输有关联， 造成致命或者严重人身伤害或者重大财产损坏或者破坏环境的事故。（ 十）“ 危险品事故征候” 是指不同于危险品事故， 但与危险品航空运输有关联， 不一定发生在航空器上， 但造成人员受伤、 财产损坏或者破坏环境、 起火、 破损、 溢出、 液体渗漏、 放射性渗漏或者包装物未能保持完整的其他情况。 任何与危险品航空运输有关并严重危及航空器或者机上人员的事件也被认为构成危险品事故征候。（ 十一）“ 例外” 是指本规定中免于遵守通常适用于危险品某一具体项目要求的规定。（ 十二）“ 包装件” 是指包装作业的完整产品， 包括包装物和准备运输的内装物。（ 十三）“ 集合包装” 是指为便于作业和装载， 一个托运人用于装入一个或者多个包装件并组成一个操作单元的一个封闭物， 此定义不包括集装器。（ 十四）“ 集装器” 是指任何类型的货物集装箱、 航空器集装箱、带网的航空器托盘或者带网集装棚的航空器托盘， 此定义不包括集合包装。（ 十五）“ 包装物” 是指具有容纳作用的容器和任何其他部件或者材料。（ 十六）“ 始发国” 是指在其领土内最初将货物装载于航空器上的国家。（ 十七）“ 联合国编号” 是指为识别一种物质或者一组特定的物质， 而由联合国危险品运输专家委员会所指定的四位数字编码。第五条经营人和其他从事危险品航空运输活动的单位和个人从事危险品航空运输活动应当遵守现行有效的《 技术细则》 及其补充材料和任何附录， 中华人民共和国的法律、 行政法规、 规章和其他民航局规范性文件另有规定的除外。第六条从事危险品航空运输活动的相关单位应当建立自查制度，对直接关系航空运输安全的危险品航空运输手册、 管理程序、 培训大纲、 人员资质等实施自查， 使之保持最新有效， 相关规定得到严格执行。 "
									},

								],
							},


						],

					},
					{
						name: "第二章 危险品航空运输的限制和豁免",
						chapter: [{
								list: [{
									content1: "危险品航空运输应当遵守本规定和《技术细则》规定的详细规格和程序 "
								}, ],
							},
							{
								list: [{
										content1: "除本规定第十二条、第十三条予以豁免或者按照《技术细则》规定经始发国批准可以运输的情况外，禁止下列危险品装上航空器：（一）《技术细则》中规定禁止在正常情况下运输的危险品；（二） 受到感染的活动物。"
									},

								],
							},

							{
								list: [{
									content1: "禁止通过航空邮件邮寄危险品或者在航空邮件内夹带危险品，《技术细则》中另有规定的除外。禁止将危险品匿报或者谎报为普通物品作为航空邮件邮寄。邮政企业、快递企业收寄危险品的，依照《中华人民共和国邮政法》的规定处罚。 "
								}, ],
							},

							{
								list: [{
										content1: "任何航空器均不得载运《技术细则》中规定的在任何情况下禁止航空运输的物品和物质。 "
									},

								],
							},
							{
								list: [{
									content1: "符合下列情况的物质和物品，不受本规定的限制：（一）已分类为危险品的物品和物质，根据有关适航要求和运行规定，或者因《技术细则》列明的其他特殊原因需要装上航空器时。航空器上载运的上述物品和物质的替换物，或者因替换已被卸下的物品或者物质，除《技术细则》允许外，应当按本规定进行运输。（二）旅客或者机组成员携带的在《技术细则》规定范围内的特定物品和物质。"
								}, ],
							},
							{
								list: [{
									content1: "下列情况，民航地区管理局可以根据《技术细则》的规定批准运输：（一）对于《技术细则》指明经批准可以运输禁止用客机和/或者货机运输的危险品；（二）符合《技术细则》规定的其他目的的。上述情况下，运输的总体安全水平必须达到相当于《技术细则》所规定的安全水平。如果《技术细则》没有明确提及允许给予某一批准，则可寻求豁免。"
								}],
							},
							{
								list: [{
									content1: "在极端紧急或者不适宜使用其他运输方式或者完全遵照规定的要求与公共利益相违背的情况下，民航地区管理局对《技术细则》的规定可予以豁免，但在此情况下应当尽全力使运输的总体安全水平达到与这些规定要求的同等安全水平。"
								}, ],
							},

						],

					},
					{
						name: "第三章 危险品航空运输许可程序",

						chapter: [

							{

								list: [{
										content1: "经营人从事危险品航空运输，应当取得危险品航空运输许可并根据许可内容实施。 "
									},

								],
							},
							{
								list: [{
										content1: "民航地区管理局应当告知申请人有关危险品航空运输的政策和规定，为申请人申请危险品航空运输许可提供咨询和申请书的标准格式。"
									},

								],
							},

							{
								list: [{
									content1: "遇灾害运送救援人员或者物资等重大、紧急和特殊情况，民航地区管理局应当按照民航局的相关要求办理危险品航空运输许可。"
								}, ],
							},

							{
								list: [{
									content1: "民航地区管理局作出的危险品航空运输许可应当包含下列内容：（ 一） 说明经营人应按本规定和《 技术细则》 的要求， 在批准的经营范围内实施运行；（ 二） 批准运输的危险品类别；（ 三） 许可的有效期；（ 四） 必要的限制条件。 "
								}],
							},
							{
								list: [{
									content1: "国内经营人申请危险品航空运输许可的，应当符合下列条件：（一）持有公共航空运输企业经营许可证；（二）危险品航空运输手册符合危险品运输的要求；（三）危险品培训大纲符合危险品运输的要求；（四）按危险品航空运输手册建立了危险品航空运输管理和操作程序、应急方案；（五）配备了合适的和足够的人员并按危险品培训大纲完成培训并合格；（六）有能力按本规定、《技术细则》和危险品航空运输手册实施危险品航空运输。"
								}],
							},
							{
								list: [{
									content1: "国内经营人首次申请危险品航空运输许可的，应当向民航地区管理局提交下列材料：（一）申请书；（二）公共航空运输企业经营许可证复印件；（三）拟从事危险品航空运输的经营范围和危险品的类别；（四）危险品航空运输手册；（五）危险品培训大纲；（六）符合本规定及《技术细则》培训要求的说明；（七）危险品应急响应方案；（八）符合性声明；（九）民航局要求的其他材料。"
								}],
							},
							{
								list: [{
									content1: "国内经营人应当确保所提交材料的真实有效。申请材料齐全、符合法定形式的，民航地区管理局应当受理国内经营人的申请。材料不齐全或者不符合法定形式的，民航地区管理局应当当场或者在5 日内一次性通知需要补充的全部材料，逾期不通知的，自收到申请材料之日起即为受理。"
								}, ],
							},
							{
								list: [{
									content1: " 民航地区管理局对国内经营人的危险品航空运输手册、 危险品培训大纲和相关文件进行审查。 国内经营人按危险品航空运输手册建立相关管理和操作程序， 按培训大纲进行培训。 民航地区管理局对相关程序和培训质量进行检查， 确保其符合本规定和《 技术细则》 的要求。经过审查， 确认国内经营人符合本规定第十八条要求的， 由民航地区管理局为其颁发危险品航空运输许可。 经审查不合格， 民航地区管理局依法做出不予许可决定的， 应当书面告知申请人， 并说明理由。 "
								}, ],
							},
							{
								list: [{
									content1: "民航地区管理局应当自受理危险品航空运输许可的申请之日起 20 日内完成审查并做出是否许可的决定。需要进行专家评审的，民航地区管理局应当将所需的评审时间书面告知申请人，评审时间不计入作出许可的期限内。"
								}, ],
							},
							{
								list: [{
									content1: "外国经营人申请在外国地点和中国地点间的定期航线上运输危险品的，应当符合下列条件：（一）持有民航局颁发的外国航空运输企业航线经营许可；（二）获得所在国民航主管部门颁发的危险品航空运输许可或者等效文件；（三）持有所在国民航主管部门批准的危险品培训大纲或者等效文件，配备了合适的和足够的人员并按危险品培训大纲完成培训并合格；（四）持有所在国民航主管部门批准的危险品航空运输手册或者等效文件，并按危险品航空运输手册建立了危险品航空运输管理和操作程序、应急方案。"
								}, ],
							},
							{
								list: [{
									content1: "外国经营人申请在外国地点和中国地点间的定期航线上运输危险品的，应当向民航地区管理局提交下列材料：（一）申请书；（二）外国经营人所在国民航主管部门颁发的危险品航空运输许可或者等效文件；（三）拟实施危险品航空运输的经营范围和危险品的类别；（四）外国经营人所在国民航主管部门批准的危险品航空运输手册或者等效文件；（五）外国经营人所在国民航主管部门批准的危险品培训大纲或者等效文件；（六）民航局颁发给该外国经营人的航线经营许可证的复印件；（七）符合本规定及《技术细则》有关培训要求的说明；（八）民航局要求的其他材料。"
								}, ],
							},
							{
								list: [{
									content1: "申请在外国地点和中国地点间的定期航线上运输危险品的外国经营人应当在预计开始运输危险品之日 60 日前，按照本规定第二十四条的要求向民航地区管理局提出正式申请，并确保所提交材料的真实有效。申请材料齐全、符合法定形式的，民航地区管理局应当受理外国经营人的申请。材料不齐全或者不符合法定形式的，民航地区管理局应当当场或者在 5 日内一次性通知该外国经营人需要补充的全部材料，逾期不通知的，自收到申请材料之日起即为受理。"
								}, ],
							},
							{
								list: [{
									content1: "民航地区管理局应当对外国经营人的申请进行审查。经过审查，确认外国经营人符合本规定第二十三条要求的，由民航地区管理局为其颁发定期航线上危险品航空运输许可。经审查不合格，民航地区管理局依法做出不予许可决定的，应当书面告知外国经营人，并说明理由。"
								}, ],

							},
							{
								list: [{
									content1: "民航地区管理局应当自受理外国经营人在外国地点和中国地点间的定期航线上运输危险品的申请之日起 20 日内做出是否许可的决定。"
								}, ],
							},
							{
								list: [{
									content1: "外国经营人申请在外国地点和中国地点间的不定期飞行时运输危险品的，应当符合下列条件：（一）持有所在国民航主管部门颁发的危险品航空运输许可或者等效文件；（二）若从外国始发，持有危险品始发国民航主管部门颁发的危险品航空运输许可或者等效文件；（三）执行不定期飞行相关人员按危险品培训大纲完成培训并合格；（四）按危险品航空运输手册建立了危险品航空运输管理和操作程序、应急方案；（五）同中国境内符合本规定要求并经备案的地面服务代理人签订包括航空运输危险品内容的机场地面服务代理协议；（六）有能力按本规定、《技术细则》和危险品航空运输手册实施危险品航空运输。"
								}, ],
							},
							{
								list: [{
									content1: "外国经营人申请在外国地点和中国地点间的不定期飞行运输危险品的，应当向民航地区管理局提交下列材料：（一）申请书；（二）外国经营人所在国民航主管部门颁发的危险品航空运输许可文件或者等效文件；（三）若从外国始发，危险品始发国民航主管部门颁发的危险品航空运输许可文件或者等效文件；（四）拟实施危险品航空运输的经营范围和危险品类别；（五）同中国境内地面服务代理人签订的地面服务代理协议；（六）执行不定期飞行相关人员符合《技术细则》有关培训要求的说明；（七）民航局或者民航地区管理局要求的其他材料。"
								}, ],
							},
							{
								list: [{
									content1: "申请在外国地点和中国地点间的不定期飞行运输危险品的外国经营人应当在预计飞行日 7 日前向民航地区管理局提出申请。不符合此时限要求的，民航地区管理局不予受理。"
								}, ],
							},
							{
								list: [{
									content1: "申请在外国地点和中国地点间的不定期飞行运输危险品的外国经营人应当按照本规定第二十九条的要求向民航地区管理局提交申请材料，并确保所提交材料的真实有效。申请材料齐全、符合法定形式的，民航地区管理局应当受理申请；申请材料不齐全或者不符合法定要求的，民航地区管理局应当当场或者 3 日内一次性告知申请人需要补齐的全部材料，逾期不告知申请人的，自收到申请材料之日起即为受理。"
								}, ],
							},
							{
								list: [{
									content1: "民航地区管理局应当对外国经营人的申请进行审查。经过审查，外国经营人符合本规定第二十八条条件的，民航地区管理局应当为外国经营人颁发不定期飞行运输危险品的许可。经审查不合格，民航地区管理局依法做出不予许可决定的，应当书面告知外国经营人，并说明理由。民航地区管理局应当自受理申请之日起 4 日内进行审查，并做出许可或者不许可的书面决定。民航地区管理局做出不予许可决定的，还应当向外国经营人说明理由。"
								}, ],
							},
							{
								list: [{
									content1: "本节要求提交的申请材料，如使用的是中文或者英文以外的其他文字，应当附带准确的中文或者英文译本。"
								}, ],
							},
							{
								list: [{
									content1: "危险品航空运输许可的有效期最长不超过 2 年。出现下列情形之一的，危险品航空运输许可失效：（一）经营人书面声明放弃；（二）许可依法被撤销或者吊销；（三）许可有效期届满后未申请延期。"
								}, ],
							},
							{
								list: [{
									content1: "危险品航空运输许可持有人要求变更许可事项的，应当向民航地区管理局提出申请；提交材料应当包括申请书和本规定第十九条、第二十四条中发生变更的材料。符合本规定要求的，民航地区管理局应当依法办理变更手续。"
								}, ],
							},
							{
								list: [{
									content1: "经营人依据本规定第十九条、第二十四条规定在申请危险品航空运输许可时所提交的材料，在许可有效期限内发生变化的，经营人应当将更新后的材料报民航地区管理局批准或认可。"
								}, ],

							},
							{
								list: [{
									content1: "危险品航空运输许可持有人申请许可有效期延期的，应当在许可有效期届满 30 日前向民航地区管理局提出申请；提交的材料应当包括申请书和本规定第十九条、第二十四条中发生变更的材料。民航地区管理局应当在许可有效期届满前做出是否准予延期的决定；逾期未做出决定的，视为准予延期。"
								}, ],
							},
						],

					},
					{
						name: "第四章 危险品航空运输手册",
						chapter: [{
								list: [{
										content1: "国内经营人依据《公共航空运输企业经营许可规定》相关要求申请公共航空运输企业经营许可时，应当将符合本规定要求的危险品航空运输手册与其他公共航空运输企业经营许可申请材料一并提交所在地民航地区管理局进行审查。危险品航空运输手册的内容可以按照专业类别及其承担的责任编入经营人运行、地面服务和客货运输业务等其他手册中。 "
									},

								],
							},
							{
								list: [{
										content1: "国内经营人的危险品航空运输手册应当至少包括以下内容：（一）进行危险品航空运输的总政策；（二）有关危险品航空运输管理和监督的机构和职责；（三）旅客和机组人员携带危险品的限制；（四）危险品事故、危险品事故征候的报告程序；（五）货物和旅客行李中隐含危险品的识别；（六）使用自营航空器运输本经营人危险品的要求；（七）人员的培训；（八）危险品航空运输应急响应方案；（九）紧急情况下危险品运输预案；（十）其他有关安全的资料或者说明。从事危险品运输经营人的危险品航空运输手册还应当包括以下内容：（一）危险品航空运输的技术要求及其操作程序；（二）通知机长的信息。国内经营人应当采取措施保持危险品航空运输手册所有内容的实用性和有效性。"
									},

								],
							},

							{
								list: [{
										content1: " 经营人应当采取必要措施，使其人员及其货运销售代理人和地面服务代理人的人员在履行相关职责时，充分了解危险品运输手册中与其职责相关的内容，并确保危险品的操作和运输按照其危险品航空运输手册中规定的程序和要求实施。"
									},

								],
							},

							{
								list: [{
									content1: "民航地区管理局可以通过书面形式要求国内经营人对危险品运输手册的相关内容、分发或者修订做出调整。"
								}],
							},


						],

					},
					{
						name: "第五章 危险品航空运输的准备",
						chapter: [{
								list: [{
									content1: "托运人应当根据《技术细则》的规定对航空运输的危险品进行分类、识别、包装、标签和标记，提交正确填制的危险品运输文件。"
								}, ],
							},
							{
								list: [{
										content1: "航空运输的危险品所使用的包装物应当符合下列要求：（一）包装物应当构造严密，能够防止在正常运输条件下由于温度、湿度或者压力的变化，或者由于振动而引起渗漏；（二）包装物应当与内装物相适宜，直接与危险品接触的包装物不能与该危险品发生化学反应或者其他反应；（三）包装物应当符合《技术细则》中有关材料和构造规格的要求；（四）包装物应当按照《技术细则》的规定进行测试；（五）对用于盛装液体的包装物，应当能承受《技术细则》中所列明的压力而不渗漏；（六）内包装应当以防止在正常航空运输条件下发生破损或者渗漏的方式进行包装、固定或者垫衬，以控制其在外包装物内的移动。垫衬和吸附材料不得与包装物的内装物发生危险反应；（七）包装物应当在检查后证明其未受腐蚀或者其他损坏时，方可再次使用。再次使用包装物时，应当采取一切必要措施防止随后装入的物品受到污染；（八）如果由于之前内装物的性质，未经彻底清洗的空包装物可能造成危害时，应当将其严密封闭，并按其构成危害的情况加以处理；（九）包装件外部不得粘附构成危害数量的危险物质。第四十五条每一危险品包装件应当粘贴适当的标签，并且符合《技术细则》的规定，《技术细则》另有规定的除外。"
									},

								],
							},

							{
								list: [{
										content1: " 国际航空运输时，除始发国要求的文字外，标记应当加用英文。"
									},

								],
							},


						],

					},
					{
						name: "第六章 托运人的责任",
						chapter: [{
								list: [{
									content1: "托运人应当确保所有办理托运手续和签署危险品运输文件的人员已按本规定和《技术细则》要求接受相关危险品知识的培训并合格。"
								}, ],
							},
							{
								list: [{
										content1: "托运人将危险品的包装件或者集合包装件提交航空运输前，应当按照本规定和《技术细则》的规定，保证该危险品不是航空运输禁运的危险品，并正确地进行分类、包装、加标记、贴标签、提供真实准确的危险品运输相关文件。托运国家法律、法规限制运输的危险品，应当符合相关法律、法规的要求。"
									},

								],
							},

							{
								list: [{
									content1: "禁止在普通货物中夹带危险品或者将危险品匿报、谎报为普通货物进行托运。"
								}, ],
							},

							{
								list: [{
									content1: "凡将危险品提交航空运输的托运人应当向经营人提供正确填写并签字的危险品运输文件，文件中应当包括《技术细则》所要求的内容，《技术细则》另有规定的除外。危险品运输文件中应当有经危险品托运人签字的声明，表明按运输专用名称对危险品进行完整、准确地描述和该危险品是按照《技术细则》的规定进行分类、包装、加标记和贴标签，并符合航空运输的条件。必要时，托运人应当提供物品安全数据说明书或者经营人认可的鉴定机构出具的符合航空运输条件的鉴定书。托运人应当确保危险品运输文件、物品安全数据说明书或者鉴定书所列货物与其实际托运的货物保持一致。"
								}],
							},
							{
								list: [{
									content1: "国际航空运输时，除始发国要求的文字外，危险品运输文件应当加用英文。"
								}, ],
							},
							{
								list: [{
									content1: "托运人必须保留一份危险品运输相关文件至少 24 个月。上述文件包括危险品运输文件、航空货运单以及本规定和《技术细则》要求的补充资料和文件。"
								}, ],
							},
							{
								list: [{
									content1: "托运人委托的代理人的人员应当按照本规定和《技术细则》的要求接受相关危险品知识的培训并合格。"
								}],
							},
							{
								list: [{
									content1: "托运人的代理人代表托运人从事危险品航空运输活动的，适用本规定有关托运人责任的规定。"
								}],
							},
						],

					},
					{
						name: "第七章 经营人及其代理人的责任",
						chapter: [{
								list: [{
									content1: "经营人应当在民航地区管理局颁发的危险品航空运输许可所载明的范围和有效期内开展危险品航空运输活动。"
								}, ],
							},
							{
								list: [{
										content1: "经营人应当制定措施防止行李、货物、邮件及供应品中隐含危险品。"
									},

								],
							},

							{
								list: [{
									content1: "经营人接收危险品进行航空运输至少应当符合下列要求：（一）附有完整的危险品运输文件，《技术细则》另有要求的除外；（二）按照《技术细则》的接收程序对包装件、集合包装件或者装有危险品的专用货箱进行检查；（三）确认危险品运输文件的签字人已按本规定及《技术细则》的要求培训并合格。"
								}, ],
							},

							{
								list: [{
									content1: "经营人应当制定和使用收运检查单以遵守本规定第五十七条、第五十八条的规定。"
								}],
							},
							{
								list: [{
									content1: "装有危险品的包装件和集合包装件以及装有放射性物质的专用货箱应当按照《技术细则》的规定在航空器上装载。"
								}, ],
							},
							{
								list: [{
									content1: "装有危险品的包装件、集合包装件和装有放射性物质的专用货箱在装上航空器或者装入集装器之前，应当检查是否有泄漏和破损的迹象。泄漏或者破损的包装件、集合包装件或者装有危险品的专用货箱不得装上航空器。"
								}, ],
							},
							{
								list: [{
									content1: "集装器未经检查并证实其内装的危险品无泄漏或者无破损迹象之前不得装上航空器。"
								}],
							},
							{
								list: [{
									content1: "装上航空器的任何危险品包装件出现破损或者泄漏，经营人应当将此包装件从航空器上卸下，或者安排由有关机构从航空器上卸下。在此之后应当保证该托运物的其余部分符合航空运输的条件，并保证其他包装件未受污染。"
								}],
							},
							{
								list: [{
									content1: "装有危险品的包装件、集合包装件和装有放射性物质的专用货箱从航空器或者集装器卸下时，应当检查是否有破损或者泄漏的迹象。如发现有破损或者泄漏的迹象，则应当对航空器上装载危险品或者集装器的部位进行破损或者污染的检查。"
								}],
							},
							{
								list: [{
									content1: "危险品不得装在航空器驾驶舱或者有旅客乘坐的航空器客舱内，《技术细则》另有规定的除外。"
								}],
							},
							{
								list: [{
									content1: "在航空器上发现由于危险品泄漏或者破损造成任何有害污染的，应当立即进行清除。受到放射性物质污染的航空器应当立即停止使用，在任何可接触表面上的辐射程度和非固着污染超过《技术细则》规定数值的，不得重新使用。"
								}],
							},
							{
								list: [{
									content1: "装有可能产生相互危险反应的危险品包装件，不得在航空器上相邻放置或者装在发生泄漏时包装件可产生相互作用的位置上。毒性物质和感染性物质的包装件应当根据《技术细则》的规定装在航空器上。装在航空器上的放射性物质的包装件，应当按照《技术细则》的规定将其与人员、活动物和未冲洗的胶卷进行分离。"
								}],
							},
							{
								list: [{
									content1: "符合本规定的危险品装上航空器时，经营人应当保护危险品不受损坏，应当将这些物品在航空器内加以固定以免在飞行时出现任何移动而改变包装件的指定方向。对装有放射性物质的包装件，应当充分固定以确保在任何时候都符合本规定第六十七条第三款规定的分离要求。"
								}],
							},
							{
								list: [{
									content1: "贴有“仅限货机”标签的危险品包装件，按照《技术细则》的规定只能装载在货机上。"
								}],
							},
							{
								list: [{
									content1: "经营人应当确保危险品的存储符合《技术细则》中有关危险品存储、分离与隔离的要求。"
								}],
							},
							{
								list: [{
									content1: "经营人根据本规定第五十一条要求托运人提供货物符合航空运输条件的鉴定书的，应当告知托运人其认可的鉴定机构，并确保其所认可的鉴定机构满足民航局关于货物航空运输条件鉴定机构的相关规定，同时将认可的鉴定机构报民航局备案。自收到备案申请之日起 20 日内，民航局应当将鉴定机构予以备案，并对外公布。"
								}],
							},
							{
								list: [{
									content1: "经营人应当在载运危险品的飞行终止后，将危险品航空运输的相关文件至少保存 24 个月。上述文件至少包括收运检查单、危险品运输文件、航空货运单和机长通知单。"
								}],
							},
							{
								list: [{
									content1: "经营人委托地面服务代理人代表其从事与危险品航空运输地面服务的，应当同地面服务代理人签订涉及危险品航空运输的地面服务代理协议。所委托的中国境内的地面服务代理人应当符合本规定有关地面服务代理人的要求，所委托的中国境外的地面服务代理人应当符合所在地国家的相关法律、法规。经营人应当自危险品航空运输地面服务代理协议签订之日起 7 日内将所签订协议报民航地区管理局备案。"
								}],
							},
							{
								list: [{
									content1: "经营人委托货运销售代理人代表其从事货物航空运输销售活动的，应当同货运销售代理人签订包括危险品安全航空运输内容的航空货物运输销售代理协议，并确保所委托的货运销售代理人满足以下要求：（一）拥有企业法人营业执照；（二）从事危险品收运工作、货物或邮件（非危险品）收运工作的员工，从事货物或邮件的搬运、储存和装载工作的员工按照所代理的经营人认可的危险品培训大纲由符合本规定要求的培训机构培训合格；（三）在货物、邮件收运处的醒目地点展示和提供数量充足、引人注目的关于危险品运输信息的布告，以提醒注意托运物可能含有的任何危险品以及危险品违规运输的相关规定和法律责任，这些布告必须包括危险品的直观示例；（四）不得作为托运人或者代表托运人托运危险品；（五）采取适当措施防止危险品被盗或者不正当使用而使人员或者财产受到损害；（六）发生航空器事故、严重事故征候、事故征候时，向调查职能部门报告航空器上装载危险品的情况；（七）其他在经营人授权范围内代表经营人从事的危险品航空运输活动符合本规定和《技术细则》的要求。第七十五条经营人委托货运销售代理人和地面服务代理人从事货物航空运输相关业务，应当在代理协议中要求代理人对收运货物进行查验或者采取有效措施防止货物中隐含危险品。经营人应当对代理人的货物查验及相关措施进行认可并定期检查。"
								}],
							},
							{
								list: [{
									content1: "本规定所指的经营人的代理人，是指位于中国境内的代表经营人从事危险品航空运输活动的企业，包括货运销售代理人、地面服务代理人，以及其他代表经营人从事危险品航空运输活动的企业。"
								}],
							},
							{
								list: [{
									content1: "货运销售代理人从事货物航空运输销售代理活动，应当同经营人签订包括危险品安全航空运输内容的航空货物运输销售代理协议。"
								}],
							},
							{
								list: [{
									content1: "货运销售代理人不得作为托运人或者代表托运人托运危险品。"
								}],
							},
							{
								list: [{
									content1: "地面服务代理人无论是否从事危险品航空运输活动，均应当满足以下要求：（一）拥有企业法人营业执照；（二）制定危险品培训大纲并报民航地区管理局备案；（三）确保其人员已按本规定和《技术细则》的要求接受相关危险品知识的培训并合格；（四）与经营人签订包括危险品航空运输在内的地面服务代理协议；（五）制定危险品航空运输管理程序，其中应当包括地面应急程序和措施；（六）拥有经营人提供或者认可的危险品航空运输手册；（七）民航局规定的其他条件。"
								}],
							},
							{
								list: [{
									content1: "地面服务代理人从事危险品航空运输活动的，除满足本规定第七十九条规定外，还应当满足以下要求：（一）制定符合《技术细则》要求的危险品保安措施；（二）危险品的储存管理符合《技术细则》中有关危险品存储、分离与隔离的要求；（三）确保其人员在履行相关职责时，充分了解危险品运输手册中与其职责相关的内容，并确保危险品的操作和运输按照其危险品航空运输手册中规定的程序和要求实施。"
								}],
							},
							{
								list: [{
									content1: "地面服务代理人应当报所在地民航地区管理局备案。自收到备案申请之日起 20 日内，民航地区管理局应当将地面服务代理人予以备案，并对外公布。"
								}],
							},
							{
								list: [{
									content1: "地面服务代理人代表经营人从事危险品航空运输活动的，适用本规定有关经营人责任的规定。"
								}],
							},
						],

					},
					{
						name: "第八章 危险品航空运输信息",
						chapter: [{
								list: [{
									content1: "经营人在其航空器上载运危险品，应当在航空器起飞前向机长提供《技术细则》规定的书面信息。"
								}, ],
							},
							{
								list: [{
										content1: " 经营人应当在运行手册中提供信息，使机组成员能履行其对危险品航空运输的职责，同时应当提供在出现涉及危险品的紧急情况时采取的行动指南。"
									},


								],
							},

							{
								list: [{
									content1: "经营人应当确保在旅客购买机票时，向旅客提供关于禁止航空运输危险品的信息。通过互联网提供的信息可以是文字或者图像形式，但应当确保只有在旅客表示已经理解行李中的危险品限制之后，方可完成购票手续。"
								}, ],
							},

							{
								list: [{
									content1: "在旅客办理乘机手续前，经营人应当在其网站或者其他信息来源向旅客提供《技术细则》关于旅客携带危险品的限制要求。通过互联网办理乘机手续的，经营人应当向旅客提供关于禁止旅客航空运输的危险品种类的信息。信息可以是文字或者图像形式，但应当确保只有在旅客表示已经理解行李中的危险品限制之后，方可完成办理乘机手续。"
								}, {
									content1: "旅客自助办理乘机手续的，经营人应当向旅客提供关于禁止旅客航空运输的危险品种类的信息。信息应当是图像形式，并应确保只有在旅客表示已经理解行李中的危险品限制之后，方可完成办理乘机手续。 "
								}, ]
							},
							{
								list: [{
									content1: "经营人、机场管理机构应当保证在机场每一售票处、办理旅客乘机手续处、登机处以及其他旅客可以办理乘机手续的任何地方醒目地张贴数量充足的布告，告知旅客禁止航空运输危险品的种类。这些布告应当包括禁止用航空器运输的危险品的直观示例。"
								}, ],
							},
							{
								list: [{
									content1: "经营人、货运销售代理人和地面服务代理人应当在货物、邮件收运处的醒目地点展示和提供数量充足、引人注目的关于危险品运输信息的布告，以提醒托运人及其代理人注意到托运物可能含有的任何危险品以及危险品违规运输的相关规定和法律责任。这些布告必须包括危险品的直观示例。"
								}, ],
							},
							{
								list: [{
									content1: "与危险品航空运输有关的经营人、托运人、机场管理机构等其他机构应当向其人员提供信息，使其能履行与危险品航空运输相关的职责，同时应当提供在出现涉及危险品的紧急情况时采取的行动指南。"
								}, ],
							},
							{
								list: [{
									content1: "如果在飞行时发生紧急情况，如情况许可，机长应当按照《技术细则》的规定立即将机上载有危险品的信息通报有关空中交通管制部门，以便通知机场。"
								}, ],
							},
							{
								list: [{
									content1: "航空器事故或者严重事故征候可能涉及作为货物运输的危险品时，经营人应当立即将机上危险品的信息提供给处理事故或者严重事故征候的应急处置机构、经营人所在国和事故或者严重事故征候发生所在国的有关当局。当运输危险品货物的航空器发生事故征候，该经营人应当立即将机上危险品的信息提供给处理事故征候的应急处置机构和事故征候发生所在国的有关当局。提供的信息应当与向机长提供的书面信息一致。"
								}, ],
							},
							{
								list: [{
									content1: "发生危险品事故或者危险品事故征候，经营人应当向经营人所在国及事故、事故征候发生地所在国有关当局报告。初始报告可以用各种方式进行，但应当尽快完成一份书面报告。若适用，书面报告应当包括下列内容，并将相关文件的副本与照片附在书面报告上：（一）事故或者事故征候发生日期；（二）事故或者事故征候发生的地点、航班号和飞行日期；（三）有关货物的描述及货运单、邮袋、行李标签和机票等的号码；（四）已知的运输专用名称（包括技术名称）和联合国编号；（五）类别或者项别以及次要危险性；（六）包装的类型和包装的规格标记；（七）涉及数量；（八）托运人或者旅客的姓名和地址；（九）事故或者事故征候的其他详细情况；（十）事故或者事故征候的可疑原因；（十一）采取的措施；（十二）书面报告之前的其他报告情况；（十三）报告人的姓名、职务、地址和联系电话。"
								}, ],
							},
							{
								list: [{
									content1: "当在货物或者邮件中发现未申报或者错误申报的危险品时，经营人应当向经营人所在国和事件发生地所在国有关当局报告。当在旅客行李中发现根据《技术细则》要求不允许携带的危险品时，经营人应当向事件发生地所在国有关当局报告。"
								}, ],
							},

						],

					},
					{
						name: "第九章 培 训",
						chapter: [{
								list: [{
									content1: "从事危险品航空运输活动的人员应当按照本规定及《技术细则》的要求经过培训并合格。"
								}, ],
							},
							{
								list: [{
									content1: " 对从事危险品航空运输活动人员的危险品培训应当由符合本规定要求的危险品培训机构实施。经营人无论是否持有危险品航空运输许可，都应当确保其相关人员按照本规定及《技术细则》的要求进行培训并合格。"
								}, ],
							},

							{
								list: [{
									content1: "根据《技术细则》的要求，以下企业或者组织开展培训活动应当持有危险品培训大纲：（一）作为危险品航空运输托运人或者托运人代理人的企业或者其他组织；（二）国内经营人；（三）货运销售代理人；（四）地面服务代理人；（五）从事民航安全检查工作的企业。危险品培训机构可以代表上述企业或者组织制定危险品培训大纲，但在实施前应当得到委托方认可。"
								}],
							},

							{
								list: [{
									content1: "危险品培训大纲应当根据各类人员的职责制定，每种培训大纲应当包括初始培训和定期复训两个类别，并符合《技术细则》的要求。"
								}, ]
							},
							{
								list: [{
									content1: "危险品培训大纲中应当至少包括下列内容：（一）符合本规定和《技术细则》规定的声明；（二）培训课程设置及考核要求；（三）受训人员的进入条件及培训后应当达到的质量要求；（四）将使用的设施、设备的清单；（五）教员的资格要求；（六）培训教材；（七）国家法律法规的相关要求。经营人、货运销售代理人及地面服务代理人的危险品培训大纲还应包括危险品航空运输手册或者所代理经营人的危险品航空运输手册的使用要求。"
								}, ],
							},
							{
								list: [{
									content1: "本规定第九十六条（一）、（四）、（五）项规定的企业或者组织制定的危险品培训大纲，在实施前应当报民航地区管理局备案。本规定第九十六条（二）项规定的企业或者组织制定的危险品培训大纲，应当符合本规定第七条的相关要求。本规定第九十六条（三）项规定的企业或者组织制定的培训大纲，在实施前应当得到所代理的经营人的认可。"
								}, ],
							},
							{
								list: [{
									content1: "危险品培训大纲应当及时修订和更新，并持续符合本规定第九十九条的要求。"
								}, ],
							},
							{
								list: [{
									content1: "制定和持有危险品培训大纲的企业或者组织应当根据其培训大纲设置培训课程。培训课程应当包括：（一）一般知识培训：旨在熟悉一般性规定的培训；（二）专门职责培训：针对人员所承担的职责要求提供的详细培训；（三）安全培训：以危险品所具有的危险性、安全操作及应急处置程序为培训内容的培训。"
								}, ],
							},
							{
								list: [{
									content1: "培训课程中应当列明培训的具体内容、计划小时数和考试的相关要求。"
								}, ],
							},
							{
								list: [{
									content1: "培训课程所需的教材、资料应当符合国家法律、法规的规定和现行有效的《技术细则》的要求。"
								}, ],
							},
							{
								list: [{
									content1: "地面服务代理人按照经备案的培训大纲或者货运销售代理人按照所代理的经营人认可的培训大纲，由符合本规定要求的培训机构培训合格的人员，可为不同经营人代理同一类别人员的工作，但经营人应当确保其符合以下条件：（一）在同等职责范围内，其培训水平足以胜任指定的工作；（二）遵守经营人危险品手册要求。"
								}, ],
							},
							{
								list: [{
									content1: "外国经营人应当确保其在中华人民共和国境内从事危险品航空运输活动的人员按下列要求之一进行培训并合格：（一）外国经营人所在国主管部门批准或者认可的培训大纲或者其他等效文件以及中国危险品航空运输相关法律法规；（二）地面服务代理人的培训大纲以及外国经营人的差异化政策。第一百零六条为了保证知识更新，应当在前一次培训后的 24 个月内进行复训。如果复训是在前一次培训的最后 3 个月有效期内完成，则其有效期自复训完成之日起开始延长，直到前一次培训失效日起 24 个月为止。"
								}, ],
							},
							{
								list: [{
									content1: "培训记录应当保存 3 年以上并随时接受民航局或者民航地区管理局的检查。培训记录应当载明以下内容：（一）受训人员姓名；（二）最近一次完成培训的日期；（三）所使用培训教材的说明；（四）培训机构的名称和地址；（五）培训教员的姓名；（六）考核成绩；（七）表明已通过培训考核的证据。"
								}, ],
							},
							{
								list: [{
									content1: "制定和实施危险品培训大纲的企业或者组织可以设立危险品培训机构。无条件设立危险品培训机构的企业或者组织，可以委托依本规定设立的危险品培训机构根据委托方制定并符合本规定要求的培训大纲对其人员进行培训。"
								}, ],
							},
							{
								list: [{
									content1: "危险品培训机构开展危险品培训应当符合以下条件，并报民航局备案：（一）具备法人资格；（二）具有委托方提供的符合本规定要求的危险品初训和复训大纲及为委托方设计的培训课程及教材；（三）具有 3 名以上符合本规定要求的危险品培训教员；（四）具有符合教学需要的教学设施和设备。自收到备案申请之日起 20 日内，民航局将危险品培训机构予以备案，并对外公布。"
								}, ],
							},
							{
								list: [{
									content1: "为本企业人员提供培训所设立的危险品培训机构不适用本规定第一百零九条第（一）（二）项规定的条件。"
								}, ],
							},
							{
								list: [{
									content1: "危险品培训机构的教员应当满足以下条件：（一）熟悉民用航空法律、法规、规章、规定和政策；（二）从事民航相关业务 5 年以上；（三）大专以上学历；（四）通过符合本规定要求的危险品培训大纲中第六类人员的培训，并考核优秀；（五）具备相应的授课技能；（六）具备正确理解国际民航组织危险品航空运输有关规定的英语水平；（七）民航局规定的其他条件。为本企业人员提供培训所设立的危险品培训机构的教员不适用前款规定。"
								}, ],
							},
							{
								list: [{
									content1: "为本企业人员提供培训所设立的危险品培训机构，其教员应当满足以下条件：（一）熟悉民用航空法律、法规、规章、规定和政策；（二）教员是本企业的雇员；（三）从事民航相关业务 3 年以上；（四）通过符合本规定要求的危险品培训大纲中第六类人员的培训，并考核优秀；（五）具备相应的授课技能并通过评估；（六）民航局规定的其他条件。"
								}, ],
							},
							{
								list: [{
									content1: "危险品培训机构的教员必须且只能在一家培训机构注册，应当至少在 24 个月内进行授课或者参加复训。"
								}, ],
							},
							{
								list: [{
									content1: "危险品培训机构应当按照本规定第一百零七条规定为学员建立培训记录，该培训记录至少保存 3 年以上并随时接受民航局或者民航地区管理局的检查。"
								}, ],
							},

						],

					},
					{
						name: "第十章 其他要求",
						chapter: [{
								list: [{
									content1: "从事危险品航空运输的经营人及其地面服务代理人、货运销售代理人、托运人及其代理人应当采取适当措施防止危险品被盗或者不正当使用而使人员或者财产受到损害。 "
								}, ],
							},
							{
								list: [{
									content1: "从事高危危险品航空运输的托运人和经营人应当制定保安计划，并及时修订其保安计划，以保持其保安计划的实用性和有效性。高危危险品是指《技术细则》中规定的有可能在恐怖主义事件中被滥用，可能造成大量伤亡或者大规模破坏等严重后果的危险品。"
								}, ],
							},

							{
								list: [{
									content1: "国内经营人的运行规范中应当包括危险品航空运输的有关内容。"
								}],
							},

							{
								list: [{
									content1: "机场管理机构应当制定机场危险品应急救援预案，将其纳入民用运输机场突发事件应急救援预案管理，并按《民用运输机场突发事件应急救援管理规则》执行。"
								}],
							},
							{
								list: [{
									content1: "机场管理机构应当及时修订机场危险品应急救援预案，确保该应急救援预案的有效性和实用性。机场管理机构应将机场危险品的管理和机场危险品应急救援预案内容纳入《民用机场使用手册》。"
								}],
							},
							{
								list: [{
									content1: "航空器事故、严重事故征候、事故征候的调查规定和调查程序应当包括涉及危险品的内容。"
								}],
							},
							{
								list: [{
									content1: "从事危险品航空运输的经营人、货运销售代理人、地面服务代理人、托运人及其代理人应当向航空器事故、严重事故征候、事故征候的调查职能部门报告航空器上装载危险品的情况。"
								}],
							},


						],

					},
					{
						name: "第十一章 监督管理",
						chapter: [{
								list: [{
										content1: "民航管理部门依据职责对危险品航空运输活动实施监督检查。民航地区管理局应当定期对辖区内从事危险品航空运输活动主体进行检查，并将监督检查中发现的问题及时处理并报告民航局。"
									},

								],
							},
							{
								list: [{
									content1: "民航管理部门依法对与危险品航空运输活动有关单位进行监督检查时，行使以下职权：（一）进入相关单位的营业场所或者其他有关场所进行检查；询问被调查的经营人、利害相关人或者其他有关单位或者个人，要求其说明有关情况；查阅、复印有关文件、资料。（二）对检查中发现的违法、违规行为，当场予以纠正或者要求限期改正；对依法应当给予行政处罚的行为，依照本规定和其他有关法律、法规的规定做出行政处罚决定。（三）对可能涉及危险品事故、危险品事故征候及违规运输的货物、邮件及行李等物品，要求相关单位予以妥善保存以供后续调查。（四）经本部门主要负责人批准，扣押违法运输的危险品。"
								}],
							},
							{
								list: [{
									content1: "民航管理部门依职责建立举报制度，公开举报电话、信箱或者电子邮件地址，受理有关危险品航空运输的举报。"
								}],
							},
							{
								list: [{
									content1: "从事危险品航空运输活动的单位和个人应当接受和配合民航管理部门的监督检查。"
								}],
							},
							{
								list: [{
									content1: "民航管理部门在实施危险品航空运输活动的监督管理时，不得妨碍被检查单位或者个人的正常经营活动，不得索取或者收受被许可人或者被检查单位或者个人的财物，不得谋取其他不正当利益。"
								}],
							},
							{
								list: [{
									content1: "危险品航空运输许可的批准函不得涂改、出借、买卖或者转让。危险品航空运输许可批准函遗失、损毁或者灭失的，应当及时报告颁发许可的地区管理局，并在公共媒体上发布遗失公告、声明作废后，向颁发许可的地区管理局书面申请重新领取。"
								}],
							},
							{
								list: [{
									content1: "经营人应当保证其运营条件持续符合颁发危险品航空运输许可的条件。经营人因运营条件发生变化，不再具备安全生产条件的，由民航管理部门依照《安全生产法》的规定撤销其危险品航空运输许可。"
								}],
							},
							{
								list: [{
									content1: "经营人及其代理人开展危险品航空运输活动的，应当按照有关规定向民航管理部门报送有关危险品航空运输活动的运输信息。"
								}],
							},
							{
								list: [{
									content1: "民航管理部门依职责建立危险品航空运输违法记录制度，定期通报危险品航空运输违法记录。经营人应当对有危险品航空运输违法记录的合作方采取更严格的收运检查程序，避免危险品航空运输事故的发生。"
								}],
							},
							{
								list: [{
									content1: "任何单位或者个人对危险品航空运输违法、违规行为，均有权向民航局或者民航地区管理局报告或者举报。报告或者举报采用书面形式并提供相关事实和证据的，民航局或者民航地区管理局应当根据举报情况进行必要的调查。"
								}],
							},

						],

					},
					{
						name: "第十二章 法律责任",
						chapter: [{
								list: [{
										content1: "托运人或者其代理人有下列行为之一的，由民航管理部门处以警告或者 3 万元以下的罚款：（一）违反本规定，未按要求对所托运的危险品进行分类的；（二）违反本规定，未按要求对所托运的危险品进行包装的；（三）违反本规定，未按要求对所托运的危险品加标记的；（四）违反本规定，未按要求对所托运的危险品贴标签的；（五）违反本规定，未按要求就所托运的危险品提供危险品运输相关文件的；（六）违反本规定，所托运危险品属于禁止航空运输的危险品；（七）违反本规定，托运国家法律、法规限制运输的危险品，未满足相关法律、法规要求的；（八）违反本规定第五十三条，未保留相关文件的；（九）违反本规定第八十九条，未向其人员提供相关信息或者相关指南的。"
									},

								],
							},
							{
								list: [{
										content1: "经营人有下列行为之一的，由民航管理部门处以警告或者 3 万元以下的罚款：（一）违反本规定第七条，未遵守《技术细则》规定运输危险品的；（二）违反本规定第八条或者第十四条，未经批准、未经豁免、未取得危险品航空运输许可或者未按照危险品航空运输许可内容运输危险品的；（三）违反本规定第二十条、第二十五条、第三十一条、第三十六条，在申请危险品航空运输许可时提供不真实材料的或者材料发生变化未按要求报民航地区管理局批准的；（四）违反本规定第三十九条，未按要求提供危险品航空运输手册的；（五）违反本规定第四十一条，未采取必要措施使其人员及其货运销售代理人和地面服务代理人了解危险品运输手册相关内容的；（六）违反本规定第七章第一节，未满足经营人责任有关要求的；（七）违反本规定第八章，未按要求提供危险品航空运输信息的；（八）违反本规定第一百二十七条，涂改、出借、买卖或者转让危险品航空运输许可批准函或者批准函遗失、损毁、灭失后未及时报告的；（九）违反本规定第一百二十九条，未按规定报送有关危险品航空运输活动运输信息的。经营人有本条第一款第（一）项、第（二）项行为，情节严重的，没收违法所得，可以并处违法所得一倍以下的罚款。经营人有本条第一款第（三）项行为，未提供真实材料，以欺骗等手段获得危险品航空运输许可的，由民航管理部门撤销其许可。"
									},

								],
							},
							{
								list: [{
										content1: "货运销售代理人有下列行为之一的，由民航管理部门处以警告或者 3 万元以下的罚款：（一）违反本规定第七十七条，从事危险品航空运输活动的；（二）违反本规定第七十八条，作为托运人或者代表托运人托运危险品的。第一百三十五条地面服务代理人有下列行为之一的，由民航管理部门处以警告或者 3 万元以下的罚款：（一）违反本规定第七十九条、第八十条、第八十一条，从事危险品航空运输活动的；（二）违反本规定第八十八条，未按要求提供危险品航空运输信息的；（三）违反本规定第一百二十九条，未按规定报送有关危险品航空运输活动运输信息的。地面服务代理人代表经营人从事危险品航空运输活动违反本规定的，适用本规定第一百三十三条（六）的规定。 "
									},

								],
							},
							{
								list: [{
									content1: "机场管理机构有下列行为之一的，由民航管理部门处以警告或者 3 万元以下的罚款：（一）违反本规定第八十七条、第八十九条，未按要求提供危险品航空运输信息的；（二）违反本规定第一百一十八条、第一百一十九条，未制定或者未及时修订机场危险品应急救援预案的。"
								}],
							},
							{
								list: [{
									content1: "托运人及其代理人、经营人、货运销售代理人、地面服务代理人、从事民航安全检查工作的企业以及培训机构违反本规定第九章，未满足危险品培训有关要求的，由民航管理部门处以警告或者 3 万元以下的罚款。"
								}],
							},
							{
								list: [{
									content1: "托运人及其代理人、经营人或者地面服务代理人违反本规定第一百一十五条，未采取适当措施防止危险品被盗或者不正当使用的，由民航管理部门处以警告或者 3 万元以下的罚款。"
								}],
							},
							{
								list: [{
									content1: "从事高危危险品航空运输的托运人或者经营人违反本规定第一百一十六条，未制定或者及时修订高危危险品保安计划的，由民航管理部门处以警告或者 3 万元以下的罚款"
								}],
							},
							{
								list: [{
									content1: "托运人或者其代理人、经营人或者地面服务代理人违反本规定第一百二十一条，未报告航空器上装载危险品情况的，由民航管理部门处以警告或者 3 万元以下的罚款。"
								}],
							},
							{
								list: [{
									content1: "从事危险品航空运输活动的单位和个人违反本规定第一百二十五条，拒不接受或者配合民航管理部门监督检查的，由民航管理部门处以警告或者 3 万元以下的罚款。"
								}],
							},
							{
								list: [{
									content1: "从事危险品航空运输活动的单位和个人违反本规定，构成犯罪的，依法追究刑事责任。"
								}],
							},



						],

					},
					{
						name: "第十三章 附 则",
						chapter: [{
								list: [{
									content1: "本规定中的期限以工作日计算，不含法定节假日。"
								}, ],
							},


							{
								list: [{
										content1: "香港特别行政区、澳门特别行政区和台湾地区的航空器经营人申请危险品航空运输许可，参照本规定有关外国经营人的规定执行。"
									},

								],
							},
							{
								list: [{
									content1: "本规定自 2016 年 5 月 14 日起施行。民航局 2004年 7 月 12 日发布的《中国民用航空危险品运输管理规定》同时废止。"
								}, ],
							},


						],

					},
				],
				aboutList5: [{

					chapter: [{
							list: [{
									smTitle: "范围"
								},
								{
									content1: "本标准规定了锂电池航空运输的限制条件和操作规范。本标准适用于锂电池货物和行李的航空运输。本标准不适用于锂电池的航空邮寄运输。"
								},
								// {
								// 	content2:[
								// 		{
								// 			list2:[{
								// 					smTitle: ""
								// 				},
								// 				{
								// 					content1: ""
								// 				},

								// 			],
								// 		},],
								// 		}
							],
						},
						{
							list: [{
									smTitle: "规范性引用文件"
								},
								{
									content1: "下列文件对于本文件的应用是必不可少的。凡是注日期的引用文件，仅所注日期的版本适用于本文件。凡是不注日期的引用文件，其最新版本（包括所有的修改单）适用于本文件。MH/T 1030 旅客和机组携带危险品的航空运输规范IATA 《危险品规则》（2018版）ICAO Doc 9284-AN/905 《危险物品安全航空运输技术细则》（2017-2018版）联合国 《关于危险货物运输的建议书-试验和标准手册》/ST/SG/AC.10/11/Rev.6",

								},
								// {

								// 	content2:[
								// 		{
								// 			list2:[{
								// 					smTitle: "规范性1引用文件"
								// 				},
								// 				{
								// 					content1: "范围1"
								// 				},

								// 			],
								// 		},
								// 		{
								// 			list2:[{
								// 					smTitle: "规范性1引用文件"
								// 				},
								// 				{
								// 					content1: "范2围"
								// 				},

								// 			],
								// 		}
								// 	]


								// }

							],

						},
						{
							list: [{
									smTitle: "术语和定义"
								},
								{
									content1: "下列术语和定义适用于本文件。"
								},

								{
									content2: [{
											list2: [{
													smTitle: "电池芯 cell"
												},
												{
													content1: "由一个正极和一个负极组成且两个电极之间有电位差的单一的、封闭的电化学装置。"
												},

											],

										},
										{
											list2: [{
													smTitle: "电池 battery"
												},
												{
													content1: "下用电路连接在一起的两个或多个电池芯，并安装有使用所必需的装置，如外壳、电极端子、标记和保护装置等。注：单电池芯电池在本标准中被认为是电池芯。"
												},


											],

										},
										{
											list2: [{
													smTitle: "锂金属电池芯或电池 lithium metal cell or battery"
												},
												{
													content1: "以锂金属或锂合金作为阳极的电池芯或电池。"
												},


											],
										},
										{
											list2: [{
													smTitle: "锂离子电池芯或电池 lithium ion cell or battery"
												},
												{
													content1: "正负电极都没有金属锂，而是将离子态或类原子态锂嵌于正负电极材料晶格中的电池芯或电池。注：锂离子电池芯或电池通常是可充电的二次电池。应用锂离子化学性质的锂聚合物电池芯或电池，在本标准中归MH2类为锂离子电池芯或电池。"
												},


											],
										},
										{
											list2: [{
													smTitle: "纽扣电池 button battery"
												},
												{
													content1: "整体高度小于直径的圆形小电池。"
												},


											],
										},
										{
											list2: [{
													smTitle: "额定能量 rated energy"
												},
												{
													content1: "由生产商公布的在规定条件下确定的电池芯或电池的能量值。注：额定能量的单位为瓦特小时（Wh），计算方法是将标称电压（以伏特(V)为单位）乘以额定容量（以安培小时(Ah)为单位）。"
												},


											],
										},
										{
											list2: [{
													smTitle: "额定容量 rated capacity"
												},
												{
													content1: "电池芯或电池在制造商规定的负荷、温度和电压截断点下测得的容量。注：单位为安培小时（Ah）或毫安小时(mAh)。"
												},


											],
										},
										{
											list2: [{
													smTitle: "标称电压 nominal voltage"
												},
												{
													content1: "用以标明或识别电池芯或电池的电压的近似值。注：标称电压不是输出电压，也不是输入电压。"
												},


											],
										},
										{
											list2: [{
													smTitle: "锂含量 lithium content"
												},
												{
													content1: "锂金属或锂合金电池芯或电池阳极中锂的质量。"
												},


											],
										},
										{
											list2: [{
													smTitle: "充电宝 power bank"
												},
												{
													content1: "由锂电池芯或电池、相应的电路及外壳组合而成，主要功能是为其他设备提供稳定直流输出的动力源，且可由使用者随身携带的小型移动电源。注：行李运输时，充电宝视为旅客或机组携带的备用锂电池；货物运输时，充电宝视为锂电池而不是含锂电池设备。"
												},


											],
										},
									],
								}
							],
						},
						{
							list: [{
									smTitle: "缩略语"
								},
								{
									content1: "下列缩略语适用于本文件。ELI 例外的锂离子电池（Lithium ion batteries excepted as per Section II of PI 965–967）ELM 例外的锂金属电池（Lithium metal batteries excepted as per Section II of PI 968–970）IMP 信息交换程序 （ Interline Message Procedure）PED 便携式电子设备（Portable Electronic Device）PMED 便携式电子医疗设备（Portable Medical Electronic Device）RBI 完全受限的单独的锂离子电池（Fully regulated lithium ion batteries (Class 9, UN 3480)as per Section IA and IB of PI 965）3RBM 完全受限的单独的锂金属电池（Fully regulated lithium metal batteries (Class 9, UN 3090)as per Section IA and IB of PI 968）RLI 完全受限的和设备一起的锂离子电池（Fully regulated lithium ion batteries (Class 9,UN 3481) as per Section I of PI 966 and 967）RLM 完全受限的和设备一起的锂金属电池（Fully regulated lithium metal batteries (Class 9,UN 3091) as per Section I of PI 969 and 970）",
								},

							],

						},
						{
							list: [{
									smTitle: "空运限制要求"
								},

								{

									content2: [{
											list2: [{
													smTitle: "质量管理方案"
												},
												{
													content1: "锂电池芯或锂电池的制造商应具有符合ICAO Doc 9284-AN/905（以下简称ICAO TI）和IATA《危险品规则》（以下简称IATA DGR）规定的质量管理方案。"
												},

											],
										},
										{
											list2: [{
													smTitle: "UN38.3 测试"
												},
												{
													content1: "除 5.4.5 规定的情况外，任何一种型号的锂电池芯或锂电池在交付航空运输前，均应通过联合国《关于危险货物运输的建议书-试验和标准手册》第Ⅲ部分 38.3 节要求的系列测试（以下简称 UN38.3 测试），无论锂电池所含的电池芯是否通过了 UN38.3 要求的系列测试。"
												},

											],
										},
										{
											list2: [{
													smTitle: "额定能量标记"
												},
												{
													content1: "货物运输时，按ICAO TI中锂电池包装说明第Ⅰ部分或IA运输的，2011年12月31日之后生产的锂离子电池应在外壳上标明额定能量值。按第Ⅱ部分或IB运输的，2008年12月31日之后生产的应标明额定能量值。"
												},


											],
										},
										{
											list2: [{
													smTitle: "禁止运输的锂电池"
												},
												{
													content1: "5.4.1 货物运输时，单独运输的锂金属电池（UN3090）和锂离子电池（UN3480）不应使用客机运输，除非根据 ICAO TI 和 IATA DGR 特殊规定 A201 条款的要求，获得相关国家主管当局的书面豁免。5.4.2 货物运输时，单独运输的锂离子电池（UN3480），如果其所处的荷电状态超过其额定容量的 30%，不应航空运输，除非根据 ICAO TI 和 IATA DGR 特殊规定 A331 条款的要求，获得始发国和经营人所属国主管当局的批准并且符合这些主管当局制定的书面条件。5.4.3 根据 ICAO TI 和 IATA DGR 特殊规定 A154 条款，因为安全原因被制造商确认为有缺陷或已被损坏的锂电池（例如因安全原因被生产商召回的电池），有可能会演变发生发热、燃烧和短路的潜在危险，不应航空运输。5.4.4 根据 ICAO TI 和 IATA DGR 特殊规定 A183 条款，不应航空运输废弃锂电池，以及为回收或处理目的运输的锂电池，除非得到始发国和经营人所属国主管当局的书面批准。5.4.5 未经过 UN38.3 测试的锂电池芯或锂电池，不应航空运输，除非满足 ICAO TI 和 IATA DGR 特殊规定 A88 条款规定的条件，并获得始发国主管当局的书面批准。"
												},


											],
										},
										{
											list2: [{
													smTitle: "国家和经营人差异"
												},
												{
													content1: "锂电池航空运输应遵守始发国、中转国、目的地国、经营人所属国等相关国家主管当局以及经营人发布的有关航空运输锂电池的差异。"
												},


											],
										},
									]


								}

							],

						},
						{
							list: [{
									smTitle: "锂电池作为货物运输的要求"
								},
								{

									content2: [{
											list2: [{
													smTitle: "基本要求"
												},
												{
													content1: "6.1.1 锂电池是第 9 类杂项危险品，航空运输时应符合 ICAO TI 和 IATA DGR 规定的所有相关要求，运输企业和人员应具备相应的危险品操作资质。6.1.2 锂电池航空运输时适用的联合国编号和运输专用名称如下：a) UN3480，锂离子电池（lithium ion batteries）；b) UN3481，锂离子电池与设备包装在一起（lithium ion batteries packed with equipment）；c) UN3481，锂离子电池安装在设备中（lithium ion batteries contained in equipment）；d) UN3090，锂金属电池（lithium metal batteries）；e) UN3091，锂金属电池与设备包装在一起（lithium metal batteries packed with equipment）；f) UN3091，锂金属电池安装在设备中（lithium metal batteries contained in equipment）。6.1.3 运输专用名称中的“设备”是指由锂电池芯或锂电池提供运行电力的装置。完全由锂电池驱动的车辆（如电动自行车、电动轮椅、平衡车）应按联合国编号 UN3171 和运输专用名称“电池供电车辆”办理运输"
												},

											],
										},
										{
											list2: [{
													smTitle: "按包装说明 965～970 第Ⅰ节运输"
												},
												{
													content1: "按包装说明965～970第Ⅰ节运输的锂电池货物，包装应符合ICAO TI 和IATA DGR包装说明965～970第Ⅰ节（包括IA及IB）的规定，见表1。按照包装说明965的第Ⅰ节和968的第Ⅰ节运输的锂电池包装件或集合包装件,在储存和装载时应与第1类(1.4S除外) 、第2.1项、第3类、第4.1项和第5.1项危险品货物实施隔离，以防在破损或起火时发生危险反应。"
												},

											],
										},
										{
											list2: [{
													smTitle: "按包装说明 965～970 第Ⅱ节运输"
												},
												{
													content1: "按包装说明965～970第Ⅱ节运输的锂电池货物，包装应符合ICAO TI 和IATA DGR包装说明965～970第Ⅱ节的规定，见表2。满足包装说明965～970第Ⅱ节要求的锂电池货物，除应符合ICAO TI关于邮件运输危险品要求以及危险品事故、事故征候报告的要求外，交运的锂电池芯和电池如果不是禁止运输的，则不受ICAO TI其他要求的限制。满足包装说明965第Ⅱ节和968第Ⅱ节要求的锂电池货物，还应符合ICAO TI关于驾驶舱和客机的装载限制以及货机的装载限制。此类货物运输时托运人不必填写危险品申报单。"
												},


											],
										},

									]


								}

							],

						},
						{
							list: [{
									smTitle: "锂电池作为行李运输的要求"
								},
								{

									content2: [{
											list2: [{
													smTitle: "适用范围"
												},
												{
													content1: "7.1.1 满足以下条件的锂电池可作为行李运输：a) 仅限旅客和机组人员为个人自用目的所携带；b) 由锂电池驱动的小型含锂电池设备，主要包括：——便携式电子设备（PED），如手表、计算器、照相机、手机、手提电脑、便携式摄像机、平衡车、扫地机器人等；——便携式电子吸烟装置，如电子香烟、电子烟、电子雪茄、电子烟斗、个人喷雾器、个人电子尼古丁输送系统等；——便携式电子医疗设备(PMED)，如自动体外除颤器、喷雾器、持续气道正压呼吸器等；——电动轮椅或类似的代步工具，供由于残障、健康或年龄原因而行动受限或暂时行动不便的旅客使用；——保密型设备，如外交公文包、现金箱、现金袋等；c) 设备所需的备用锂电池（含充电宝）。7.1.2 超重行李中的锂电池，还应满足 MH/T 1030 的运输要求。"
												},

											],
										},
										{
											list2: [{
													smTitle: "锂含量和额定能量限制"
												},
												{
													content1: "7.2.1 PED 中的锂电池和备用锂电池7.2.1.1 锂金属或锂合金电池的锂含量应不超过 2 g。7.2.1.2 锂离子电池的额定能量应不超过 100 Wh。如果大于 100 Wh 但不超过 160 Wh，经航空经营人批准后，方可运输。超过 160 Wh 的，不应作为行李运输。7.2.2 便携式电子吸烟装置及备用锂电池7.2.2.1 锂金属电池的锂含量应不超过 2 g。7.2.2.2 锂离子电池的额定能量应不超过 100 Wh。7.2.3 PMED 中的锂电池和备用锂电池7.2.3.1 锂金属电池的锂含量应不超过 8 g。7.2.3.2 锂离子电池的额定能量应不超过 160 Wh。7.2.4 电动轮椅或类似代步工具7.2.4.1 如锂电池可卸下，其额定能量应不超过 300 Wh。7.2.4.2 如锂电池不可卸，则无额定能量限制。"
												},


											],
										},
										{
											list2: [{
													smTitle: "UN38.3 测试要求"
												},
												{
													content1: "根据ICAO TI第8部分和IATA DGR第2.3章的规定，作为行李运输的锂电池芯和电池所属类型应符合UN38.3规定的每项试验的要求。必要时，旅客和机组应提供证明以确认符合这一要求。"
												},


											],
										},
										{
											list2: [{
													smTitle: "保护措施"
												},
												{
													content1: "7.4.1 备用电池应单个做好保护以防短路，包括将备用电池放置于原厂零售包装中或对电极进行绝缘处理，例如可将暴露的电极用胶布粘住，或者将每一块电池单独装在塑料袋或者绝缘保护袋中。7.4.2 安装有锂电池的设备应有防止设备意外启动的措施。如托运，应完全关闭（不在睡眠或休眠模式），并采取措施防止意外启动设备，防止设备损坏。"
												},


											],
										},
										{
											list2: [{
													smTitle: "数量限制"
												},
												{
													content1: "7.5.1 超过 100 Wh 但不超过 160 Wh 的备用锂电池（除轮椅外），每位旅客和机组人员可携带的数量不应超过 2 块。7.5.2 对于可卸下的轮椅用锂电池，旅客可携带 1 块不超过 300 Wh 的备用锂电池，或 2 块均不超过160 Wh 的备用锂电池。"
												},


											],
										},
										{
											list2: [{
													smTitle: "行李类型"
												},
												{
													content1: "7.6.1 含锂电池设备7.6.1.1 PED 和 PMED 可托运、手提或随身携带。7.6.1.2 便携式电子吸烟装置不应托运，可手提或随身携带。7.6.1.3 电动轮椅或代步工具应托运，如锂电池可卸，应卸下并且手提或随身携带。7.6.2 备用锂电池备用锂电池不应托运。"
												},


											],
										},

										{
											list2: [{
													smTitle: "充电宝"
												},
												{
													content1: "7.7.1 充电宝在本标准中视为备用锂电池，应满足本章关于备用锂电池的相关要求。7.7.2 充电宝在飞机上应全程处于关闭状态。7.7.3 不应在飞机上使用充电宝为设备充电。7.7.4 不应在飞机上对充电宝充电。7.7.5 机上广播应包含充电宝的内容。"
												},


											],
										},
										{
											list2: [{
													smTitle: "额定能量或容量标记"
												},
												{
													content1: "7.8.1 备用锂电池和充电宝外部应标明锂电池的额定容量和标称电压，或者标明锂电池的额定能量。7.8.2 未标记或标注不清晰，也无法提供其他有效证明（如产品说明书），无法确定锂电池额定能量或锂含量的锂电池，经营人可拒绝运输。7.8.3 具体要求见表 3。"
												},
											],
										},


									]


								}

							],

						},
					]
				}],


				CarrierCode: 'CZ',
				AirwaysCustomerRules: null,
				query:''
			}
		},
		created() {
			that = this;
			that.CarrierCode = that.$route.query.code;
			console.log(that.CarrierCode);

			GetAirwaysCustomerRule();
		},
		mounted() {
			console.log('当前地址：' + this.$route.path);
			$(window).scrollTop("0");
		}
	}

	function GetAirwaysCustomerRule() {
		yqfApi.GetAirwaysCustomerRule({
				CarrierCode: that.CarrierCode
			},
			function(result) {
				console.log(result);
				if (result.code == 0) {
					that.AirwaysCustomerRules = result.data.AirwaysCustomerRules;
				} else {
					that.$confirm(result.msg, '提示', {
						distinguishCancelAndClose: true,
						confirmButtonText: '确定'
					}).then(() => {
						that.$router.push({
							path: '/Flight'
						});
					});
				}
			}
		);
	}
</script>

<style lang="scss">
	@import '../../style/Flight/flight.scss';
</style>
